import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectorRef } from "@angular/core";
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import {
	GrupoClientes
} from "@sharedV11/classes/clients/client/grupos-cliente-Respuesta.model";
import { HttpErrorsService } from "@sharedV11/services/alerts/errors/http-errors.service";
import { SnackbarInfoService } from "@sharedV11/services/alerts/snackbar-info/snackbar-info.service";
import { GlobalServicCentros } from "@sharedV11/services/global/global.service centros";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { Translator } from "@sharedV11/services/translator/translator.service";
import { DualListComponent } from "angular-dual-listbox";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import {
	DatosLista
} from "../../categorias-jerarquias/model/model";
import { ConectarApiService } from "@sharedV11/services/api/connection/conectar-api.service";
import { MaestrasService } from "@sharedV11/services/core/maestras.service";
import { ApiTokenService } from "@sharedV11/services/api/token/api-token.service";
import { InsUpEnlaceMenuRequest, InsUpEnlaceMenuResponse, IEnlaceMenu, IEnlaceMenuFormValue, IEnlaceMenuScript, ICalendario, IBotones, BOTONES_DEFAULT, IOtrasConfiguraciones } from "../model/model";
import moment from "moment";
import { IdiomaGR } from "@modelosV6/grupos-recintos-Respuesta.model";


@Component({
	selector: "app-edit-enlace-menu",
	templateUrl: "./edit-enlace-menu.component.html",
	styleUrls: ["./edit-enlace-menu.component.scss"],
})
export class EditEnlaceMenuComponent implements OnInit, OnChanges {

	changeName(arg0: any, arg1: string) {
		throw new Error('Method not implemented.');
	}

	public loading: boolean = true;
	private ngUnsubscribe = new Subject();

	@Input() pkId: string;
	@Input() mode: string;
	@Input() modificar: boolean;

	translation: any;
	editForm: FormGroup;

	entityValue: IEnlaceMenu;

	// datos lista
	padres: DatosLista[] = [];

	// Tipo Elemento
	tipoElemento = [
		{
			name: "Tienda",
			value: 2,
		},
		{
			name: "Restauración",
			value: 3,
		},
	];

	//grupos internet dual list
	gruposInternetSinAsignar = [];
	gruposInternetAsignados = [];

	listaPaises: Array<{name: string, code: string}> = [];

	//centros
	format = {
		add: "Añadir",
		remove: "Borrar",
		all: "Todos",
		none: "Ninguno",
		direction: DualListComponent.LTR,
		draggable: true,
		locale: "es",
	};

	//
	editorListaIdiomas: Array<IdiomaGR> = [];
	idiomasApp: Array<IdiomaGR>;
	tiposIdiomasAPI: any;
	tiposIdiomas: any;
	//centros
	centrosSinAsignar = [];
	centrosAsignados = [];
	tipoCentros: any[] = [];
	//idiomas
	idiomasSinAsignar: any[];
	idiomasAsignados: any[] = [];
	datosIdiomas: any[] = [];
	//idiomas activos para calendario
	idiomasActivosSinAsignar: any[] = [];
	idiomasActivosAsignados: any[] = [];
	pendingIdiomaVisitaCodes: string[] | null = null;
	idiomasActivosSourceForCalendario: any[] = [];
	//tipocentro
	editorListaTipoClienteIdioma = [];
	tipoClienteIdiomaAPI: any;
	tipoClienteIdioma: any;
	
	// Calendario - Grupos Internet para selects múltiples
	gruposInternetFiltrosSinAsignar: any[] = [];
	gruposInternetFiltrosAsignados: any[] = [];
	gruposInternetNoMostrarSinAsignar: any[] = [];
	gruposInternetNoMostrarAsignados: any[] = [];
	gruposInternetPorRecintoSinAsignar: any[] = [];
	gruposInternetPorRecintoAsignados: any[] = [];
	
	// Flag para detectar cambios en calendario
	hasCalendarChanges: boolean = false;
	originalCalendarState: any = null;

	listaTiposCliente: any[] = [];

	// listas fijas
	listaTipoEnlace = this.tipificarElementos(["B2C","Administracion","B2B","API"]);
	listaVisible = this.tipificarElementos(["No visible","Visible","No visible en portada"]);
	listaUnidadTiempo = this.tipificarElementosFromElements(["Meses","Dias","Horas","Minutos"]);
	listaSolicitarRegistro = this.tipificarElementos(["Registro directo","Solicita registro"]);
	listaSolicitarFactura = this.tipificarElementos([
		"No solicitar factura",
		"Solicitar factura",
		"Solicitar factura (2)",
		"Solicitar factura (3)",
		"Solicitar factura (4)",
		"Solicitar factura (5)",
	]);
	listaValidarHoraVisita = this.tipificarElementos(["0","1","2","3","4"]);
	listaVerEspectaculos = this.tipificarElementos([
		"No ver espectáculos",
		"Ver espectáculo",
		"Ver espectáculos (2)",
		"Ver espectáculos (3)",
	]);
	listaCompraDesdeAdmin = this.tipificarElementos(["No","Si","Paga con Phone & Sell"]);
	listaValidarReglas = this.tipificarElementos(["No validar","Validar"]);
	listaVerProductosRelacionados = this.tipificarElementos([
		"No ver productos relacionados",
		"Ver productos relacionados (1)",
		"Ver productos relacionados (2)",
		"Ver productos relacionados (3)",
		"Ver productos relacionados (4)",
	]);
	listaVerCodigosPromocionales = this.tipificarElementos([
		"No mostrar",
		"Mostrar sólo codigos promocionales",
		"Mostrar sólo vales promocionales",
		"Mostrar sólo codigos y vales promocionales",
	]);
	listaLogueo = this.tipificarElementos([
		"No visible/Acceso Agente",
		"Compra directa",
		"Solicita inicio sesión",
		"Opcional inicio de sesión en paso 3",
		"Obligatorio inicio de sesión en paso 3",
	], -1);


	datosCompra: any[] = [];
	datosPublicidad: any[] = [];
	datosCompraControl: any[] = [];
	datosCompraPoliticaControl: any[] = [];
	datosFactura: any[] = [];
	pasesDatosPersonales: any[] = [];
	
	// Elementos base disponibles del JSON
	datosCompraBase: any[] = [];
	datosPublicidadBase: any[] = [];
	datosCompraControlBase: any[] = [];
	datosCompraPoliticaControlBase: any[] = [];
	datosFacturaBase: any[] = [];
	pasesDatosPersonalesBase: any[] = [];
	
	caracteristicasCalendario: ICalendario;
	listados: any[] = [];

	estructuraBase: any;

	// Button configuration properties
	tiposPago: any[] = [];
	hasButtonChanges: boolean = false;
	originalButtonState: IBotones | null = null;

	// Other configurations properties
	hasOtherConfigChanges: boolean = false;
	originalOtherConfigState: any | null = null;

	constructor(
		private snackvar_service: SnackbarInfoService,
		private panelService: PanelService,
		private fb: FormBuilder,
		private translator: Translator,
		private httpErrorService: HttpErrorsService,
		private gsCentros: GlobalServicCentros,
		private conectarApiService: ConectarApiService,
		private maestras: MaestrasService,
		private servicioAPI: ConectarApiService,
		private tokenService: ApiTokenService,
		private cdr: ChangeDetectorRef,
	) {}

	ngOnDestroy(): void {
		//Called once, before the instance is destroyed.
		//Add 'implements OnDestroy' to the class.
		this.ngUnsubscribe.next();
		this.ngUnsubscribe.complete();
	}

	ngOnInit(): void {
		this.findEnlaceMenuBase();
		this.initializeTranslate();
		this.initializeFormWithoutData();
		this.setupNivelPadreSubscription();
		//this.loadData();
		this.cargarDatosAsync();
	}

	ngOnChanges(changes: SimpleChanges): void {
		// Detectar cambios en pkId o mode después de la inicialización
		if (changes['pkId'] || changes['mode']) {
			const pkId = changes['pkId']?.currentValue ?? this.pkId;
			const mode = changes['mode']?.currentValue ?? this.mode;
			
			// Solo cargar datos si tenemos un pkId válido y estamos en modo Update o Duplicate
			if (pkId && (mode === "U" || mode === "D")) {
				this.manageForm(pkId, mode);
			}
		}
	}

	tipificarElementos(elements: string[], startIndex: number = 0) {
		return elements.map((e,idx) => ({ 'value' : startIndex + idx, 'name': e }))
	}

	tipificarElementosFromElements(elements: string[]) {
		return elements.map(e => ({ 'value' : e.toLowerCase(), 'name': e }))
	}

	async cargarDatosAsync(): Promise<boolean> {

		this.loadIdiomas();
		this.loadCentros();
		this.loadTipoClienteIdioma();
		this.loadTiposCliente();
		this.loadGruposInternet();
		this.loadIdiomasActivos();
		this.loadListados();
		this.loadTiposPago();

		this.manageForm(this.pkId, this.mode);

		return true;
	}

	async loadListados() {
		this.servicioAPI.getListadosDeImpresionOnline(null, null).subscribe(
			(data) => {
				this.listados = [];
				if (data?.DatosResult?.ListaListados && data.DatosResult.ListaListados.length > 0) {
					this.listados = data.DatosResult.ListaListados.map((item: any) => {
						const desc = item.Description ?? item.Descripcion ?? item.description ?? item.descripcion ?? item.Fichero ?? item.Nombre ?? '';
						const label = (item.pkId != null && item.pkId !== '') ? `${item.pkId} - ${desc}` : desc;
						return {
							pkId: item.pkId,
							pkid: item.pkId,
							Nombre: label,
							nombre: label,
							Fichero: item.Fichero ?? item.Nombre ?? ''
						};
					});
				}
				this.cdr.detectChanges();
			},
			(error) => {
				this.httpErrorService.identificarErrores(error);
			}
		);
	}

	async loadIdiomas() {
		let resultado: boolean = false;
		//centros en cargar datos
		await this.servicioAPI.getIdiomasAsync(null, null, "1").then((data) => {
			this.tiposIdiomasAPI = data;
			if (this.tiposIdiomasAPI.DatosResult != null) {
				this.tiposIdiomas = this.tiposIdiomasAPI.DatosResult.ListaIdiomas;
			this.editorListaIdiomas = this.tiposIdiomas;
			this.addIdiomasControlInForm(this.tiposIdiomas);

			this.idiomasSinAsignar = this.tiposIdiomas;
			}
			if (this.pendingIdiomaVisitaCodes?.length) {
				this.idiomasActivosAsignados = this.getAssignedActiveLanguagesFromCodes(this.pendingIdiomaVisitaCodes);
				this.syncActiveLanguagesSourceForCalendar();
				this.cdr.detectChanges();
			} else {
				this.syncActiveLanguagesSourceForCalendar();
			}
			this.normalizeUnassignedActiveLanguagesToLocaleCodes();
		},
		(error) => {
			this.httpErrorService.identificarErrores(error);
			resultado = false;
		});
	}

	/** Actualiza CodIdioma/pkId en idiomasActivosSinAsignar de numérico a código locale cuando editorListaIdiomas está disponible (evita duplicado en dual-list). */
	private normalizeUnassignedActiveLanguagesToLocaleCodes(): void {
		const lista = this.editorListaIdiomas || this.tiposIdiomas || [];
		if (!lista.length || !this.idiomasActivosSinAsignar?.length) return;
		this.idiomasActivosSinAsignar.forEach((item: any) => {
			const raw = item?.CodIdioma ?? item?.pkId;
			if (raw == null || raw === '') return;
			if (/^\d+$/.test(String(raw))) {
				const numVal = typeof raw === 'number' ? raw : parseInt(String(raw), 10);
				const ref = lista.find((t: any) => (t?.pkId ?? t?.pkid ?? t?.id) == numVal);
				const codeRef = ref?.CodIdioma ?? ref?.codIdioma ?? ref?.codigo ?? ref?.Codigo;
				if (codeRef != null && codeRef !== '' && !/^\d+$/.test(String(codeRef))) {
					item.CodIdioma = codeRef;
					item.pkId = codeRef;
				}
			}
		});
		this.syncActiveLanguagesSourceForCalendar();
		this.cdr.detectChanges();
	}

	async loadTipoClienteIdioma() {
		let resultado: boolean = false;
		//centros en cargar datos
		await this.servicioAPI.TraerDatosListasAsync('tipoclienteidioma').subscribe(data => {
			this.tipoClienteIdiomaAPI = data;
			if (this.tipoClienteIdiomaAPI.DatosResult != null) {
				this.tipoClienteIdioma = this.tipoClienteIdiomaAPI.DatosResult.ListaIdiomas;
				this.editorListaTipoClienteIdioma = this.tipoClienteIdioma;
			}
		},
		(error) => {
			this.httpErrorService.identificarErrores(error);
			resultado = false;
		});
	}

	async loadCentros() {
		await this.gsCentros.getCentros();
	}

	loadTiposCliente(): void {
		this.conectarApiService.getDatosListasMS({ nombreTabla: 'tipoCliente' }).subscribe(
			(data) => {
				this.listaTiposCliente = [];
				const listas = data?.datosResult?.datosListas ?? [];
				if (Array.isArray(listas) && listas.length > 0) {
					this.listaTiposCliente = listas.map((item: any) => ({
						id: item.pkid ?? item.id ?? item.Id ?? item.pkId,
						name: item.nombre ?? item.Nombre ?? item.name ?? ""
					})).filter((item: any) => item.id != null && item.id !== undefined);
				}
			},
			(error) => {
				this.loading = false;
				this.httpErrorService.identificarErroresMicroservicios(error);
			}
		);
	}

	async loadGruposInternet() {

		this.conectarApiService.getDatosListasMS({
			nombreTabla: 'gruposinternet'
		}).subscribe((data) => {
			this.gruposInternetSinAsignar = [];
			if (data?.datosResult?.datosListas && data?.datosResult?.datosListas.length > 0) {
				this.gruposInternetSinAsignar = data?.datosResult?.datosListas;
				// Inicializar también las listas para los selects múltiples del calendario
				this.gruposInternetFiltrosSinAsignar = [...data?.datosResult?.datosListas];
				this.gruposInternetNoMostrarSinAsignar = [...data?.datosResult?.datosListas];
				this.gruposInternetPorRecintoSinAsignar = [...data?.datosResult?.datosListas];
			}
		}, (error) => {
			this.loading = false;
			this.httpErrorService.identificarErroresMicroservicios(error);
		});
	}

	async loadIdiomasActivos() {
		this.conectarApiService.getDatosListasMS({
			nombreTabla: 'idiomas',
			NombreCampo: 'bActivo',
			FiltroCampo: '1'
		}).subscribe((data) => {
			this.idiomasActivosSinAsignar = [];
			if (data?.datosResult?.datosListas && data?.datosResult?.datosListas.length > 0) {
				const codFrom = (item: any) => item?.codIdioma ?? item?.CodIdioma ?? item?.cod_idioma ?? item?.chIdioma ?? item?.codigo ?? item?.Codigo ?? item?.id ?? item?.pkId ?? item?.pkid ?? item?.cod ?? item?.code;
				const listaRef = this.editorListaIdiomas || this.tiposIdiomas || [];
				this.idiomasActivosSinAsignar = data.datosResult.datosListas.map((item: any) => {
					const raw = codFrom(item);
					let codParaKey = raw;
					if (raw != null && raw !== '' && /^\d+$/.test(String(raw))) {
						const numVal = typeof raw === 'number' ? raw : parseInt(String(raw), 10);
						const ref = listaRef.find((t: any) => (t?.pkId ?? t?.pkid ?? t?.id) == numVal);
						const codeRef = ref?.CodIdioma ?? ref?.codIdioma ?? ref?.codigo ?? ref?.Codigo;
						if (codeRef != null && codeRef !== '' && !/^\d+$/.test(String(codeRef))) {
							codParaKey = codeRef;
						}
					}
					return { CodIdioma: codParaKey, Nombre: item?.nombre ?? item?.Nombre ?? "", pkId: codParaKey };
				});
			}
			if (this.pendingIdiomaVisitaCodes?.length) {
				this.idiomasActivosAsignados = this.getAssignedActiveLanguagesFromCodes(this.pendingIdiomaVisitaCodes);
				this.syncActiveLanguagesSourceForCalendar();
				this.cdr.detectChanges();
			} else {
				this.syncActiveLanguagesSourceForCalendar();
			}
		}, (error) => {
			this.loading = false;
			this.httpErrorService.identificarErroresMicroservicios(error);
		});
	}

	async loadTiposPago() {
		this.conectarApiService.getDatosListasMS({
			nombreTabla: 'tipopago'
		}).subscribe((data) => {
			this.tiposPago = [];
			if (data?.datosResult?.datosListas && data?.datosResult?.datosListas.length > 0) {
				this.tiposPago = data.datosResult.datosListas;
			}
		}, (error) => {
			this.loading = false;
			this.httpErrorService.identificarErroresMicroservicios(error);
		});
	}

	async initializeTranslate() {
		this.translation = this.translator.GetTranslations();
		this.format = {
			add: this.translation?.Anadir,
			remove: this.translation?.Borrar,
			all: this.translation?.Todos,
			none: this.translation?.Ninguno,
			direction: DualListComponent.LTR,
			draggable: true,
			locale: "es",
		};
		// Actualizar this.translation cuando el idioma se cargue o cambie (use() async)
		this.translator.dataLanguage$
			.pipe(takeUntil(this.ngUnsubscribe))
			.subscribe((data) => {
				if (data) {
					this.translation = data;
					this.format = {
						add: this.translation?.Anadir,
						remove: this.translation?.Borrar,
						all: this.translation?.Todos,
						none: this.translation?.Ninguno,
						direction: DualListComponent.LTR,
						draggable: true,
						locale: "es",
					};
					this.cdr.detectChanges();
				}
			});
	}

	addIdiomasControlInForm(tiposIdiomas) {
		tiposIdiomas.map((idioma) => {
			this.editForm.addControl(
				"Nombre-" + idioma.CodIdioma,
				new FormControl("")
			);
			this.editForm.addControl(
				"Descripcion-" + idioma.CodIdioma,
				new FormControl("")
			);
			this.editForm.addControl(
				"UrlExterna-" + idioma.CodIdioma,
				new FormControl("")
			);
			this.editForm.addControl(
				"NombreBoton-" + idioma.CodIdioma,
				new FormControl("")
			);
			this.editForm.addControl(
				"TextoAmigable-" + idioma.CodIdioma,
				new FormControl("")
			);
		});
	}

	findEnlaceMenuBase() {
		
		// nos queda el objeto base
		this.conectarApiService
			.obtenerEnlacesMenuByPkid("0", 1)
			.then(
				(base) => {
					this.estructuraBase = base;
					// Guardar elementos base disponibles
					this.datosCompraBase = this.estructuraBase.JSONConfiguracion?.CaracteristicasAdicionales?.DatosCompra || [];
					this.datosPublicidadBase = this.estructuraBase.JSONConfiguracion?.CaracteristicasAdicionales?.DatosPublicidad || [];
					this.datosCompraControlBase = this.estructuraBase.JSONConfiguracion?.CaracteristicasAdicionales?.DatosCompraControl || [];
					this.datosCompraPoliticaControlBase = this.estructuraBase.JSONConfiguracion?.CaracteristicasAdicionales?.DatosCompraPoliticaControl ?? this.estructuraBase.JSONConfiguracion?.CaracteristicasAdicionales?.datosCompraPoliticaControl ?? [];
					this.datosFacturaBase = this.estructuraBase.JSONConfiguracion?.CaracteristicasAdicionales?.DatosFactura || [];
					this.pasesDatosPersonalesBase = this.estructuraBase.JSONConfiguracion?.CaracteristicasAdicionales?.PasesDatosPersonales || [];
					this.applyVisibleModeToFeatures();
				}
			);
	}

	/** Devuelve lista base con propiedad visible. Respeta visible del backend cuando added trae cada elemento con visible; si no, true si está en added. */
	mergeBaseWithVisible(base: any[], added: any[]): any[] {
		if (!base || base.length === 0) return [];
		const addedByName: Record<string, any[]> = {};
		(added || []).forEach((a: any) => {
			const k = a.name != null ? String(a.name) : '';
			if (!addedByName[k]) addedByName[k] = [];
			addedByName[k].push(a);
		});
		const usedByName: Record<string, number> = {};
		return base.map((b: any) => {
			const k = b.name != null ? String(b.name) : '';
			const list = addedByName[k] || [];
			const used = usedByName[k] || 0;
			const correspondingItem = used < list.length ? list[used] : null;
			if (correspondingItem != null) usedByName[k] = used + 1;
			const visible = correspondingItem != null
				? (correspondingItem.visible !== undefined ? this.convertToBoolean(correspondingItem.visible) : true)
				: false;
			return correspondingItem != null ? { ...b, ...correspondingItem, visible } : { ...b, visible };
		});
	}

	/** Aplica modo visible: convierte los 6 arrays a lista completa con visible (solo si la base está cargada). */
	applyVisibleModeToFeatures(): void {
		if (this.datosCompraBase?.length > 0) {
			this.datosCompra = this.mergeBaseWithVisible(this.datosCompraBase, this.datosCompra);
			this.datosPublicidad = this.mergeBaseWithVisible(this.datosPublicidadBase, this.datosPublicidad);
			this.datosCompraControl = this.mergeBaseWithVisible(this.datosCompraControlBase, this.datosCompraControl);
			this.datosCompraPoliticaControl = this.mergeBaseWithVisible(this.datosCompraPoliticaControlBase, this.datosCompraPoliticaControl);
			this.datosFactura = this.mergeBaseWithVisible(this.datosFacturaBase, this.datosFactura);
			this.pasesDatosPersonales = this.mergeBaseWithVisible(this.pasesDatosPersonalesBase, this.pasesDatosPersonales);
		}
	}

	/** Para UI dual list: solo elementos con visible === true (lado "añadidos"). */
	private getVisibleAdded(arr: any[]): any[] {
		return (arr || []).filter((e: any) => e.visible === true);
	}

	/** Para payload: enviar todos los elementos recibidos del backend, con visible y atributos actualizados (el backend exige mismo conjunto de campos que el objeto base). */
	private getAllForPayload(arr: any[]): any[] {
		return arr || [];
	}

	get datosCompraAdded(): any[] { return this.getVisibleAdded(this.datosCompra); }
	get datosPublicidadAdded(): any[] { return this.getVisibleAdded(this.datosPublicidad); }
	get datosCompraControlAdded(): any[] { return this.getVisibleAdded(this.datosCompraControl); }
	get datosCompraPoliticaControlAdded(): any[] { return this.getVisibleAdded(this.datosCompraPoliticaControl); }
	get datosFacturaAdded(): any[] { return this.getVisibleAdded(this.datosFactura); }
	get pasesDatosPersonalesAdded(): any[] { return this.getVisibleAdded(this.pasesDatosPersonales); }

	findEnlaceMenu(pkId) {
		// Primera consulta: esBase=0 para obtener datos generales (Calendario, Botones, GruposInternet, campos no-array de CaracteristicasAdicionales)
		this.conectarApiService
			.obtenerEnlacesMenuByPkid(pkId, 0)
			.then(
				(dataEsBase0) => {
					// Segunda consulta: esBase=1 para obtener arrays específicos (DatosCompra, DatosPublicidad, DatosCompraControl, DatosFactura, etc.)
					// Esta se ejecuta SECUENCIALMENTE después de que esBase=0 termine
					this.conectarApiService
						.obtenerEnlacesMenuByPkid(pkId, 1)
						.then(
							(dataEsBase1) => {
								// Combinar ambas respuestas: 
								// - Prioridad esBase=1 para arrays (DatosCompra, DatosPublicidad, etc.)
								// - Prioridad esBase=0 para campos generales (no-array)
								const mergedData = this.mergeEnlaceMenuData(dataEsBase1, dataEsBase0);
								if (mergedData) {
									this.entityValue = mergedData;
									
									// PRIMERO asignar los arrays a las variables del componente
									// Cargar solo los elementos añadidos (no todos los elementos base)
									// Los elementos base ya están cargados en findEnlaceMenuBase()
									if (mergedData.JSONConfiguracion?.CaracteristicasAdicionales?.DatosCompra) {
										this.datosCompra = mergedData.JSONConfiguracion.CaracteristicasAdicionales.DatosCompra || [];
									}

									if (mergedData.JSONConfiguracion?.CaracteristicasAdicionales?.DatosPublicidad) {
										this.datosPublicidad = mergedData.JSONConfiguracion.CaracteristicasAdicionales.DatosPublicidad || [];
									}

									if (mergedData.JSONConfiguracion?.CaracteristicasAdicionales?.DatosCompraControl) {
										this.datosCompraControl = mergedData.JSONConfiguracion.CaracteristicasAdicionales.DatosCompraControl || [];
									}

									const politicaMerged = mergedData.JSONConfiguracion?.CaracteristicasAdicionales?.DatosCompraPoliticaControl ?? mergedData.JSONConfiguracion?.CaracteristicasAdicionales?.datosCompraPoliticaControl;
									if (politicaMerged) {
										this.datosCompraPoliticaControl = Array.isArray(politicaMerged) ? politicaMerged : [];
									}

									if (mergedData.JSONConfiguracion?.CaracteristicasAdicionales?.DatosFactura) {
										this.datosFactura = mergedData.JSONConfiguracion.CaracteristicasAdicionales.DatosFactura || [];
									}

									if (mergedData.JSONConfiguracion?.CaracteristicasAdicionales?.PasesDatosPersonales) {
										this.pasesDatosPersonales = mergedData.JSONConfiguracion.CaracteristicasAdicionales.PasesDatosPersonales || [];
									}
									this.applyVisibleModeToFeatures();
									// DESPUÉS llamar a changeValueForm con los datos y arrays ya asignados
									this.changeValueForm(mergedData);
									this.gruposInternetAsignados = this.getGruposInternetAsignados(
										(mergedData?.GruposInternet || []).reduce((curr,acc) => curr + (curr ? ',' : '') + acc.GrupoInternetId, '') || ''
									);
									// En edición: limitar opciones de Calendario a los Grupos Internet del enlace
									this.gruposInternetFiltrosSinAsignar = [...this.gruposInternetAsignados];
									this.gruposInternetNoMostrarSinAsignar = [...this.gruposInternetAsignados];
									this.gruposInternetPorRecintoSinAsignar = [...this.gruposInternetAsignados];
								}

								this.valuedChanged();
								this.loading = false;
							},
							(error1) => {
								// Si falla esBase=1 (segunda llamada), usar solo datos de esBase=0 que ya tenemos
								if (dataEsBase0) {
									this.entityValue = dataEsBase0;
									this.changeValueForm(dataEsBase0);
									this.gruposInternetAsignados = this.getGruposInternetAsignados(
										(dataEsBase0?.GruposInternet || []).reduce((curr,acc) => curr + (curr ? ',' : '') + acc.GrupoInternetId, '') || ''
									);
									// En edición: limitar opciones de Calendario a los Grupos Internet del enlace
									this.gruposInternetFiltrosSinAsignar = [...this.gruposInternetAsignados];
									this.gruposInternetNoMostrarSinAsignar = [...this.gruposInternetAsignados];
									this.gruposInternetPorRecintoSinAsignar = [...this.gruposInternetAsignados];
									
									// Asignar arrays de esBase=0
									if (dataEsBase0.JSONConfiguracion?.CaracteristicasAdicionales?.DatosCompra) {
										this.datosCompra = dataEsBase0.JSONConfiguracion.CaracteristicasAdicionales.DatosCompra || [];
									}
									if (dataEsBase0.JSONConfiguracion?.CaracteristicasAdicionales?.DatosPublicidad) {
										this.datosPublicidad = dataEsBase0.JSONConfiguracion.CaracteristicasAdicionales.DatosPublicidad || [];
									}
									if (dataEsBase0.JSONConfiguracion?.CaracteristicasAdicionales?.DatosCompraControl) {
										this.datosCompraControl = dataEsBase0.JSONConfiguracion.CaracteristicasAdicionales.DatosCompraControl || [];
									}
									const politicaEsBase0 = dataEsBase0.JSONConfiguracion?.CaracteristicasAdicionales?.DatosCompraPoliticaControl ?? dataEsBase0.JSONConfiguracion?.CaracteristicasAdicionales?.datosCompraPoliticaControl;
									if (politicaEsBase0) {
										this.datosCompraPoliticaControl = Array.isArray(politicaEsBase0) ? politicaEsBase0 : [];
									}
									if (dataEsBase0.JSONConfiguracion?.CaracteristicasAdicionales?.DatosFactura) {
										this.datosFactura = dataEsBase0.JSONConfiguracion.CaracteristicasAdicionales.DatosFactura || [];
									}
									if (dataEsBase0.JSONConfiguracion?.CaracteristicasAdicionales?.PasesDatosPersonales) {
										this.pasesDatosPersonales = dataEsBase0.JSONConfiguracion.CaracteristicasAdicionales.PasesDatosPersonales || [];
									}
									this.applyVisibleModeToFeatures();
									this.valuedChanged();
								}
								this.loading = false;
								this.httpErrorService.identificarErrores(error1);
							}
						);
				},
				(error0) => {
					// Si falla esBase=0 (primera llamada), no podemos continuar con esBase=1
					// Manejar el error directamente
					this.loading = false;
					this.httpErrorService.identificarErrores(error0);
					// Intentar cargar solo con esBase=1 como fallback
					this.conectarApiService
						.obtenerEnlacesMenuByPkid(pkId, 1)
						.then(
							(dataEsBase1) => {
								if (dataEsBase1) {
									this.entityValue = dataEsBase1;
									this.changeValueForm(dataEsBase1);
									this.gruposInternetAsignados = this.getGruposInternetAsignados(
										(dataEsBase1?.GruposInternet || []).reduce((curr,acc) => curr + (curr ? ',' : '') + acc.GrupoInternetId, '') || ''
									);
									// En edición: limitar opciones de Calendario a los Grupos Internet del enlace
									this.gruposInternetFiltrosSinAsignar = [...this.gruposInternetAsignados];
									this.gruposInternetNoMostrarSinAsignar = [...this.gruposInternetAsignados];
									this.gruposInternetPorRecintoSinAsignar = [...this.gruposInternetAsignados];
									
									if (dataEsBase1.JSONConfiguracion?.CaracteristicasAdicionales?.DatosCompra) {
										this.datosCompra = dataEsBase1.JSONConfiguracion.CaracteristicasAdicionales.DatosCompra || [];
									}

									if (dataEsBase1.JSONConfiguracion?.CaracteristicasAdicionales?.DatosPublicidad) {
										this.datosPublicidad = dataEsBase1.JSONConfiguracion.CaracteristicasAdicionales.DatosPublicidad || [];
									}

									if (dataEsBase1.JSONConfiguracion?.CaracteristicasAdicionales?.DatosCompraControl) {
										this.datosCompraControl = dataEsBase1.JSONConfiguracion.CaracteristicasAdicionales.DatosCompraControl || [];
									}

									const politicaEsBase1 = dataEsBase1.JSONConfiguracion?.CaracteristicasAdicionales?.DatosCompraPoliticaControl ?? dataEsBase1.JSONConfiguracion?.CaracteristicasAdicionales?.datosCompraPoliticaControl;
									if (politicaEsBase1) {
										this.datosCompraPoliticaControl = Array.isArray(politicaEsBase1) ? politicaEsBase1 : [];
									}

									if (dataEsBase1.JSONConfiguracion?.CaracteristicasAdicionales?.DatosFactura) {
										this.datosFactura = dataEsBase1.JSONConfiguracion.CaracteristicasAdicionales.DatosFactura || [];
									}

									if (dataEsBase1.JSONConfiguracion?.CaracteristicasAdicionales?.PasesDatosPersonales) {
										this.pasesDatosPersonales = dataEsBase1.JSONConfiguracion.CaracteristicasAdicionales.PasesDatosPersonales || [];
									}
									this.applyVisibleModeToFeatures();
									this.valuedChanged();
								}
								this.loading = false;
							},
							(error1) => {
								this.loading = false;
								this.httpErrorService.identificarErrores(error1);
							}
						);
					}
			);
	}

	/**
	 * Combina datos de dos consultas: esBase=1 (datos generales) y esBase=0 (DatosCompra y campos relacionados)
	 * Prioridad esBase=0 para arrays de datos, prioridad esBase=1 para resto de campos
	 */
	mergeEnlaceMenuData(dataEsBase1: any, dataEsBase0: any): any {
		
		if (!dataEsBase1 && !dataEsBase0) {
			return null;
		}
		
		if (!dataEsBase1) {
			return dataEsBase0;
		}
		
		if (!dataEsBase0) {
			return dataEsBase1;
		}

		// Combinar CaracteristicasAdicionales
		const caracteristicasEsBase1 = dataEsBase1.JSONConfiguracion?.CaracteristicasAdicionales || {};
		const caracteristicasEsBase0 = dataEsBase0.JSONConfiguracion?.CaracteristicasAdicionales || {};
		// Estructura (orden, cantidad) desde esBase=1; valores desde esBase=0 por índice (evita duplicados por name).
		const mergeArrayStructureFromBase1ValuesFromBase0 = (arrEsBase0: any[], arrEsBase1: any[]): any[] => {
			if (arrEsBase1 == null || !Array.isArray(arrEsBase1)) return arrEsBase0 ?? [];
			if (arrEsBase0 == null || !Array.isArray(arrEsBase0)) return arrEsBase1 ?? [];
			return arrEsBase1.map((item1, i) => {
				const from0 = arrEsBase0[i];
				return from0 != null ? { ...item1, ...from0 } : item1;
			});
		};

		const mergedCaracteristicas = {
			...caracteristicasEsBase0,
			DatosCompra: mergeArrayStructureFromBase1ValuesFromBase0(
				dataEsBase0.JSONConfiguracion?.CaracteristicasAdicionales?.DatosCompra ?? [],
				caracteristicasEsBase1.DatosCompra ?? []
			),
			DatosPublicidad: mergeArrayStructureFromBase1ValuesFromBase0(
				dataEsBase0.JSONConfiguracion?.CaracteristicasAdicionales?.DatosPublicidad ?? [],
				caracteristicasEsBase1.DatosPublicidad ?? []
			),
			DatosCompraControl: mergeArrayStructureFromBase1ValuesFromBase0(
				dataEsBase0.JSONConfiguracion?.CaracteristicasAdicionales?.DatosCompraControl ?? [],
				caracteristicasEsBase1.DatosCompraControl ?? []
			),
			DatosCompraPoliticaControl: mergeArrayStructureFromBase1ValuesFromBase0(
				dataEsBase0.JSONConfiguracion?.CaracteristicasAdicionales?.DatosCompraPoliticaControl ?? dataEsBase0.JSONConfiguracion?.CaracteristicasAdicionales?.datosCompraPoliticaControl ?? [],
				caracteristicasEsBase1.DatosCompraPoliticaControl ?? caracteristicasEsBase1.datosCompraPoliticaControl ?? []
			),
			DatosFactura: mergeArrayStructureFromBase1ValuesFromBase0(
				dataEsBase0.JSONConfiguracion?.CaracteristicasAdicionales?.DatosFactura ?? [],
				caracteristicasEsBase1.DatosFactura ?? []
			),
			PasesDatosPersonales: mergeArrayStructureFromBase1ValuesFromBase0(
				dataEsBase0.JSONConfiguracion?.CaracteristicasAdicionales?.PasesDatosPersonales ?? [],
				caracteristicasEsBase1.PasesDatosPersonales ?? []
			)
		};

		// Combinar JSONConfiguracion: TODO viene de esBase=0, solo se actualiza CaracteristicasAdicionales
		const mergedJSONConfiguracion = {
			...(dataEsBase0.JSONConfiguracion || {}), // Base con TODO de esBase=0
			CaracteristicasAdicionales: mergedCaracteristicas // Solo actualizar CaracteristicasAdicionales con arrays de esBase=1
		};

		// Combinar objeto completo: TODO viene de esBase=0, solo JSONConfiguracion tiene arrays de esBase=1
		const mergedData = {
			...dataEsBase0, // Base con TODOS los datos de esBase=0 (campos raíz: Nombre, Descripcion, TipoEnlace, GruposInternet, Calendario, Botones, etc.)
			JSONConfiguracion: mergedJSONConfiguracion // JSONConfiguracion con arrays de esBase=1 y resto de esBase=0
		};

		return mergedData;
	}

	mergeWithBase(data, base) {

		return base.map((item => {

			// me quedo con el elemento que vino por api si existe
			// o el base en su defecto
			return data?.find(original => original.name === item.name) || item;

		}));
	}

	getAvailableElements(baseElements: any[], addedElements: any[]): any[] {
		if (!baseElements || baseElements.length === 0) {
			return [];
		}

		if (!addedElements || addedElements.length === 0) {
			return baseElements;
		}

		const addedNames = addedElements.map(elem => elem.name).filter(name => name);

		return baseElements.filter(elem => {
			if (!elem.name) {
				return true;
			}
			return !addedNames.includes(elem.name);
		});
	}

	getGruposInternetAsignados(joinIds: string) {
		if (!joinIds || joinIds.length === 0) return [];
		const ids = joinIds.split(",").map((id) => id.trim()).map(Number);
		const gruposAsignados = this.gruposInternetSinAsignar.filter((grupo) =>
			ids.includes(grupo.pkid)
		);

		return gruposAsignados;
	}

	getIdiomasAsignados(joinIds: string) {
		if (!joinIds || joinIds.length === 0) return [];
		const ids = joinIds.split(",").map((id) => id.trim()).map(String);
		const idiomasAsignados = this.idiomasSinAsignar.filter((idioma) =>
			ids.includes(idioma.CodIdioma)
		);

		return idiomasAsignados;
	}

	getAssignedActiveLanguagesFromCodes(codes: string[]) {
		if (!codes || codes.length === 0) return [];
		const normalize = (cod: any) => cod != null && cod !== '' ? String(cod) : null;
		const codesLower = codes.map((c) => String(c).toLowerCase());
		const matchCode = (c: string | null) => c && codesLower.includes(c.toLowerCase());
		const fromSource = this.idiomasActivosSinAsignar.filter((idioma) => {
			const codIdioma = normalize(idioma.CodIdioma ?? idioma.codIdioma ?? idioma._id ?? idioma.pkId);
			return matchCode(codIdioma);
		}).map(idioma => ({
			CodIdioma: idioma.CodIdioma ?? idioma.codIdioma ?? idioma._id ?? idioma.pkId,
			Nombre: idioma.Nombre ?? idioma.nombre ?? '',
			pkId: idioma.CodIdioma ?? idioma.codIdioma ?? idioma.pkId ?? idioma._id
		}));
		const foundCods = new Set(fromSource.map((i: any) => normalize(i.CodIdioma ?? i.pkId)?.toLowerCase()));
		const listaBase = this.editorListaIdiomas || this.tiposIdiomas || [];
		const byCode = listaBase.filter((t: any) => {
			const c = normalize(t.CodIdioma ?? t.codIdioma ?? t.pkId ?? t._id);
			return c && matchCode(c) && !foundCods.has(c.toLowerCase());
		}).map((t: any) => {
			const cod = t.CodIdioma ?? t.codIdioma ?? t.pkId ?? t._id;
			return { CodIdioma: cod, Nombre: t.Nombre ?? t.nombre ?? '', pkId: cod };
		});
		const result = fromSource.length > 0 || byCode.length > 0 ? [...fromSource, ...byCode] : fromSource;
		return result;
	}

	syncActiveLanguagesSourceForCalendar(destination?: any[]) {
		const dest = destination !== undefined ? destination : this.idiomasActivosAsignados;
		const cod = (a: any) => (a?.CodIdioma ?? a?.codIdioma ?? a?.pkId) != null ? String(a.CodIdioma ?? a.codIdioma ?? a.pkId).toLowerCase() : null;
		const seen = new Set<string>();
		this.idiomasActivosSourceForCalendario.length = 0;
		for (const a of this.idiomasActivosSinAsignar || []) {
			const c = cod(a);
			if (c && !seen.has(c)) { seen.add(c); this.idiomasActivosSourceForCalendario.push(a); }
		}
		for (const a of dest || []) {
			const c = cod(a);
			if (c && !seen.has(c)) { seen.add(c); this.idiomasActivosSourceForCalendario.push(a); }
		}
	}

	onCalendarLanguagesDestinationChange(dest: any[]) {
		this.syncActiveLanguagesSourceForCalendar(dest);
	}

	getGruposInternetAsignadosFromIds(ids: number[]) {
		if (!ids || ids.length === 0) return [];
		return this.gruposInternetSinAsignar.filter((grupo) =>
			ids.includes(grupo.pkid)
		);
	}

	initializeFormWithoutData() {
		this.editForm = this.fb.group({
			Nombre: ["", Validators.required],
			Descripcion: [""],
			TipoEnlace: [0],
			Visible: [0, Validators.required],
			SinFecha: [false],
			Audioguia: [false],
			VerCodigosPromocionales: [""],
			Activo: [true],
			Nivel: ["", [Validators.maxLength(2), Validators.pattern(/^\d{0,2}$/)]],
			Padre: [""],
			Orden: ["", [Validators.maxLength(2), Validators.pattern(/^\d{0,2}$/)]],
			DiasCalendario: ["", [Validators.maxLength(3), Validators.pattern(/^\d{0,3}$/)]],
			TiempoVentaMin: ["", [Validators.required, Validators.maxLength(3), Validators.pattern(/^\d{0,3}$/)]],
			TiempoVentaMinTipo: ["", Validators.required],
			TiempoVentaMax: ["", [Validators.required, Validators.maxLength(3), Validators.pattern(/^\d{0,3}$/)]],
			TiempoVentaMaxTipo: ["", Validators.required],
			TiempoReservaMin: ["", [Validators.maxLength(3), Validators.pattern(/^\d{0,3}$/)]],
			TiempoReservaMinTipo: [""],
			TiempoReservaMax: ["", [Validators.required, Validators.maxLength(3), Validators.pattern(/^\d{0,3}$/)]],
			TiempoReservaMaxTipo: ["", Validators.required],
			Logueo: ["", Validators.required],
			SolicitaVerificarRegistro: [0, Validators.required],
			SolicitaFactura: ["", Validators.required],
			TiposClientes: [[], [Validators.required, (c: AbstractControl) => (Array.isArray(c.value) && c.value.length > 0) ? null : { required: true }]],
			LetraLocalizador: ["", Validators.maxLength(3)],
			ValidarHoraVisita: ["", Validators.required],
			VerEspectaculos: [0, Validators.required],
			CompraDesdeAdmin: [0, Validators.required],
			ValidarReglas: [1, Validators.required],
			VerProductosRelacionados: [0],
			SaltarValidacionPrecio: [true],
			EntradasNominativas: [false, Validators.required],
			DatosCompraIds: [""],
			DatosPublicidadIds: [""],
			DatosCompraControlIds: [""],
			DatosCompraPoliticaControlIds: [""],
			DatosFacturaIds: [""],
			PasesPersonales: [""],
			Idiomas: [""],
			GruposInternetIds: [""],
			JSONConfiguracion: [""],
			Botones: [""],
			Calendario: [""],
			ClaveEmpresa: [""],
			GruposInternet: [""],
			ListadoId: [""],
			ListadoReservaId: [""],
			//campos personalizados

			Requerido: [""],
			Requerido2: [""],
			customLabel: [""],
			customAdded: [""],
			customNombre: [""],

			// Campos de configuración de calendario
			Visibilidad: [""],
			Defecto: [""], 
			Paso1: [""], 
			Paso2: [""], 
			CalendarioDisponible: [false],
			CalendarioPorRecinto: [false],
			
			// Filtros por Grupo Internet
			FiltrosPorGI_GruposInternet: [],
			FiltrosPorGI_NivelEducativo: [false],
			FiltrosPorGI_RangoEdad: [false], 
			FiltrosPorGI_TipoTabla: [false],
			FiltrosPorGI_CalendariosDia: [""],
			FiltrosPorGI_Idiomas: [""],
			
			// No mostrar calendario
			GINoMostrarCalendario: [""],
			
			// Calendario por recinto
			CalendarioPorRecintoGI: [""],
			
			// Campos legacy (mantener para compatibilidad)
			Visiblidad: [""],
			FiltrosPorGI: [""],
			RangoEdad: [""], 
			TipoTabla: [""],
			NivelEducativo: [""],
			CalendariosDia: [""], 
			CalendarioIdiomas: [""], 
			NoMostrarCalendario: [""],

			// Configuración de los botones - General buttons
			Botones_PhoneSell: [false],
			Botones_Comprar: [true],
			Botones_Reservar: [false],
			Botones_Factura: [true],
			Botones_MisCompras: [false],
			Botones_MisReservas: [false],
			Botones_MisDatos: [false],
			Botones_MisOperaciones: [true],
			Botones_PayGold: [true],
			Botones_ComprarMas: [false],
			Botones_PagoDiferido: [true],

			// Configuración de los botones - Modo Admin
			Botones_ModoAdmon_Modificar_Unidades: [0],
			Botones_ModoAdmon_Modificar_Tipo: [""],
			Botones_ModoAdmon_Modificar_Hora: [""],
			Botones_ModoAdmon_Pagar_Unidades: [0],
			Botones_ModoAdmon_Pagar_Tipo: [""],
			Botones_ModoAdmon_Pagar_Hora: [""],
			Botones_ModoAdmon_Anular_Unidades: [0],
			Botones_ModoAdmon_Anular_Tipo: [""],
			Botones_ModoAdmon_Anular_Hora: [""],

			// Configuración de los botones - Formas de pago (FormArray)
			Botones_FormasdePago: this.fb.array([]),

			// Otras configuraciones
			OtrasConfig_DobleLayoutEntradas: [true],
			OtrasConfig_ListaEspera: [false],
			OtrasConfig_CompraPases: [false],
			OtrasConfig_TiempoValidez: [""],
			OtrasConfig_TiempoValidezTipo: [""],
			OtrasConfig_AdmiteDtoPersonalizado: [false],
			OtrasConfig_BloqueoInputFactura: [false],
			OtrasConfig_OcultarAreaPersonal: [true],
			OtrasConfig_APIPDFEntradas: [true],
			OtrasConfig_EnviarEmail: [false],
			OtrasConfig_CodigoClienteAsociado: [false],
			OtrasConfig_ImportacionExcelNominativas: [false],
			OtrasConfig_APIPDFFacturas: [false],
			OtrasConfig_APIPassbook: [false],
			OtrasConfig_FechaPorRecintoEnPdf: [false],
			OtrasConfig_MostrarAforoDisponible: [false],
			OtrasConfig_MostrarItinerario: [false],
			OtrasConfig_SinPhoneShell: [false],
			OtrasConfig_CorreoReservaSinTotales: [false],
			OtrasConfig_SinTituloExposicionEnResumen: [false],
			OtrasConfig_BotonMasMenosImagen: [false],
			OtrasConfig_OcultarClientesReservasAdmin: [false],
			OtrasConfig_TitularComoVisitante: [false],
			OtrasConfig_HoraFinEnSesionFija: [false],
			OtrasConfig_MailConfirmacionVentaOpcional: [false],
			OtrasConfig_MailConfirmacionReservaOpcional: [false],
			OtrasConfig_MostrarIncluyeComision: [false],
			OtrasConfig_OcultarTarifasSinTraduccion: [false],
			OtrasConfig_MostrarIdiomaSesion: [false],
			OtrasConfig_EnviarMailCC: [false],
			OtrasConfig_ListadoId: [""],
			OtrasConfig_ListadoReservaId: [""],

		});
	}

	// Helper function to convert 0/1 to boolean for mat-slide-toggle
	private convertToBoolean(value: any): boolean {
		if (value === null || value === undefined) {
			return false;
		}
		if (typeof value === 'boolean') {
			return value;
		}
		if (typeof value === 'string') {
			const result = value === '1' || value === 'true' || value.toLowerCase() === 'true';
			return result;
		}
		const result = Number(value) === 1;
		return result;
	}

	// Helper function to convert boolean to 0/1 for API
	private convertToNumber(value: any): number {
		if (value === null || value === undefined) return 0;
		if (typeof value === 'boolean') return value ? 1 : 0;
		if (typeof value === 'string') {
			return (value === '1' || value === 'true' || value.toLowerCase() === 'true') ? 1 : 0;
		}
		return Number(value) === 1 ? 1 : 0;
	}

	private toNumberOrZero(value: any): number {
		if (value === null || value === undefined || value === "") return 0;
		if (typeof value === 'number' && !isNaN(value)) return value;
		const n = parseInt(String(value), 10);
		return isNaN(n) ? 0 : n;
	}

	changeValueForm(data: IEnlaceMenu) {
		if (!data) {
			this.editForm.reset();
			this.panelService.setDiscardChanges(true);
			return;
		}

		// scriptData?.location?.address?.streetAddress || ''
		this.formControls["Nombre"].setValue(data.Nombre);
		this.formControls["Descripcion"].setValue(data.Descripcion);
		this.formControls["TipoEnlace"].setValue(data.TipoEnlace);
		// Visible es un mat-select con valores 0, 1, 2, no un booleano
		const visibleValue = data.Visible !== null && data.Visible !== undefined ? Number(data.Visible) : 0;
		// Convertir valores 0/1 a booleanos para mat-slide-toggle
		const sinFechaBoolean = this.convertToBoolean(data.SinFecha);
		const activoBoolean = this.convertToBoolean(data.Activo);
		
		this.formControls["Visible"].setValue(visibleValue, { emitEvent: false });
		this.formControls["SinFecha"].setValue(sinFechaBoolean, { emitEvent: false });
		this.formControls["VerCodigosPromocionales"].setValue(data.VerCodigosPromocionales);
		this.formControls["Activo"].setValue(activoBoolean, { emitEvent: false });
		// Forzar actualización de los controles para que Angular Material detecte los cambios
		this.formControls["Activo"].updateValueAndValidity({ emitEvent: false });
		this.formControls["SinFecha"].updateValueAndValidity({ emitEvent: false });
		
		this.formControls["Nivel"].setValue(data.Nivel);
		this.formControls["Padre"].setValue(data.Padre);
		this.updatePadreDisabledState();
		this.formControls["Orden"].setValue(data.Orden);
		this.formControls["DiasCalendario"].setValue(data.DiasCalendario);
		this.formControls["TiempoVentaMin"].setValue(data.TiempoVentaMin);
		this.formControls["TiempoVentaMinTipo"].setValue(data.TiempoVentaMinTipo);
		this.formControls["TiempoVentaMax"].setValue(data.TiempoVentaMax);
		this.formControls["TiempoVentaMaxTipo"].setValue(data.TiempoVentaMaxTipo);
		this.formControls["TiempoReservaMin"].setValue(data.TiempoReservaMin);
		this.formControls["TiempoReservaMinTipo"].setValue(data.TiempoReservaMinTipo);
		this.formControls["TiempoReservaMax"].setValue(data.TiempoReservaMax);
		this.formControls["TiempoReservaMaxTipo"].setValue(data.TiempoReservaMaxTipo);
		this.formControls["Logueo"].setValue(data.Logueo);
		this.formControls["SolicitaVerificarRegistro"].setValue(data.SolicitaVerificarRegistro != null && data.SolicitaVerificarRegistro !== undefined ? data.SolicitaVerificarRegistro : 0);//
		this.formControls["SolicitaFactura"].setValue(data.SolicitaFactura); //
		// TiposClientes: backend envía string "1,2,3"; el form usa array para mat-select multiple
		const tiposClientesRaw = data.TiposClientes;
		if (Array.isArray(tiposClientesRaw)) {
			this.formControls["TiposClientes"].setValue(tiposClientesRaw);
		} else if (tiposClientesRaw != null && String(tiposClientesRaw).trim() !== "") {
			const ids = String(tiposClientesRaw).split(",").map((s: string) => s.trim()).filter((s: string) => s);
			this.formControls["TiposClientes"].setValue(ids.map((id: string) => parseInt(id, 10)).filter((n: number) => !isNaN(n)));
		} else {
			this.formControls["TiposClientes"].setValue([]);
		}
		this.formControls["Idiomas"].setValue(data.Idiomas);
		// Cargar idiomas del acordeón: idiomasAsignados y controles por idioma (Nombre-XX, Descripcion-XX, etc.)
		const idiomasData = Array.isArray(data.Idiomas) ? data.Idiomas : (data.Idiomas && typeof data.Idiomas === "object") ? [data.Idiomas] : [];
		this.idiomasAsignados = idiomasData.length ? idiomasData.map((item: any) => ({
			CodIdioma: item.CodIdioma || item.codIdioma,
			Nombre: item.NombreIdioma || item.Nombre || item.nombre || "",
			Descripcion: item.DescripcionIdioma || item.Descripcion || item.descripcion || "",
			NombreBoton: item.nombreBoton || item.NombreBoton || "",
			TextoAmigable: item.TextoAmigable || item.textoAmigable || "",
			UrlExterna: item.urlExterna || item.UrlExterna || ""
		})) : [];
		idiomasData.forEach((item: any) => {
			const cod = item.CodIdioma || item.codIdioma;
			if (cod && this.formControls["Nombre-" + cod]) {
				this.formControls["Nombre-" + cod].setValue(item.NombreIdioma || item.Nombre || item.nombre || "");
				this.formControls["Descripcion-" + cod].setValue(item.DescripcionIdioma || item.Descripcion || item.descripcion || "");
				this.formControls["NombreBoton-" + cod].setValue(item.nombreBoton || item.NombreBoton || "");
				this.formControls["TextoAmigable-" + cod].setValue(item.TextoAmigable || item.textoAmigable || "");
				this.formControls["UrlExterna-" + cod].setValue(item.urlExterna || item.UrlExterna || "");
			}
		});
		const letraLocalizador = (data as any).LetraLocalizador != null && (data as any).LetraLocalizador !== undefined ? (data as any).LetraLocalizador : "";
		this.formControls["LetraLocalizador"].setValue(letraLocalizador || "");
		const audioguiaBoolean = this.convertToBoolean(data.Audioguia);
		this.formControls["Audioguia"].setValue(audioguiaBoolean, { emitEvent: false });
		this.formControls["Audioguia"].updateValueAndValidity({ emitEvent: false });
		this.formControls["JSONConfiguracion"].setValue(data.JSONConfiguracion);
		this.formControls["Botones"].setValue(data.Botones);
		
		this.formControls["ClaveEmpresa"].setValue(data.ClaveEmpresa);
		this.formControls["GruposInternet"].setValue(data.GruposInternet);
		this.formControls["ListadoId"].setValue(data.ListadoId);
		this.formControls["ListadoReservaId"].setValue(data.ListadoReservaId);

		this.formControls["Calendario"].setValue(data.Calendario);
		if (data.Calendario?.CaracteristicasCalendario){
			const caracteristicas = data.Calendario.CaracteristicasCalendario;
			
			// Visibilidad
			this.formControls["Visibilidad"].setValue(caracteristicas.Visibilidad || "");
			this.formControls["Visiblidad"].setValue(caracteristicas.Visibilidad || "");
			
			// Visibilidad Angular (Paso1/Paso2: un solo ID de Grupo Internet; si viene varios separados por coma, se toma el primero)
			if (caracteristicas.VisibilidadAngular) {
				this.formControls["Defecto"].setValue(caracteristicas.VisibilidadAngular.Defecto || "");
				const paso1Raw = (caracteristicas.VisibilidadAngular.Paso1 || "").toString().trim();
				const paso2Raw = (caracteristicas.VisibilidadAngular.Paso2 || "").toString().trim();
				this.formControls["Paso1"].setValue(paso1Raw ? paso1Raw.split(",")[0].trim() : "");
				this.formControls["Paso2"].setValue(paso2Raw ? paso2Raw.split(",")[0].trim() : "");
			}
			
			// Calendario Disponible
			const calDisponible = caracteristicas.CaledarioDisponible;
			this.formControls["CalendarioDisponible"].setValue(
				this.convertToBoolean(calDisponible), { emitEvent: false }
			);
			this.formControls["CalendarioDisponible"].updateValueAndValidity({ emitEvent: false });
			
			// Calendario Por Recinto
			const calPorRecinto = caracteristicas.CalendarioPorRecinto;
			this.formControls["CalendarioPorRecinto"].setValue(
				this.convertToBoolean(calPorRecinto), { emitEvent: false }
			);
			this.formControls["CalendarioPorRecinto"].updateValueAndValidity({ emitEvent: false });
			
			// GINoMostrarCalendario (array)
			if (Array.isArray(caracteristicas.GINoMostrarCalendario)) {
				this.gruposInternetNoMostrarAsignados = this.getGruposInternetAsignadosFromIds(
					caracteristicas.GINoMostrarCalendario
				);
			}
			
			// CalendarioPorRecintoGI (array)
			if (Array.isArray(caracteristicas.CalendarioPorRecintoGI)) {
				this.gruposInternetPorRecintoAsignados = this.getGruposInternetAsignadosFromIds(
					caracteristicas.CalendarioPorRecintoGI
				);
			}
			
			// FiltrosPorGI
			this.pendingIdiomaVisitaCodes = null;
			if (caracteristicas?.FiltrosPorGI) {
				// Obtener la primera clave (puede ser "0" para todos o un ID específico)
				const filtroKey = Object.keys(caracteristicas.FiltrosPorGI)[0];
				if (filtroKey) {
					const filtro = caracteristicas.FiltrosPorGI[filtroKey];
					
					// Si la clave es "0", significa "Todos"
					if (filtroKey === "0") {
						this.gruposInternetFiltrosAsignados = [];
						this.formControls["FiltrosPorGI_GruposInternet"].setValue(["0"]);
					} else {
						// Es un ID específico
						this.gruposInternetFiltrosAsignados = this.getGruposInternetAsignadosFromIds([parseInt(filtroKey)]);
						this.formControls["FiltrosPorGI_GruposInternet"].setValue([filtroKey]);
					}
					
					this.formControls["FiltrosPorGI_NivelEducativo"].setValue(this.convertToBoolean(filtro.NivelEducativo), { emitEvent: false });
					this.formControls["FiltrosPorGI_RangoEdad"].setValue(this.convertToBoolean(filtro.RangoEdad), { emitEvent: false });
					this.formControls["FiltrosPorGI_TipoTabla"].setValue(this.convertToBoolean(filtro.TipoTabla), { emitEvent: false });
					this.formControls["FiltrosPorGI_NivelEducativo"].updateValueAndValidity({ emitEvent: false });
					this.formControls["FiltrosPorGI_RangoEdad"].updateValueAndValidity({ emitEvent: false });
					this.formControls["FiltrosPorGI_TipoTabla"].updateValueAndValidity({ emitEvent: false });
					this.formControls["FiltrosPorGI_CalendariosDia"].setValue(filtro.CalendariosDia || "");
					
					if (Array.isArray(filtro.IdiomaVisita)) {
						this.pendingIdiomaVisitaCodes = [...filtro.IdiomaVisita];
						this.idiomasActivosAsignados = this.getAssignedActiveLanguagesFromCodes(filtro.IdiomaVisita);
						this.syncActiveLanguagesSourceForCalendar();
					} else {
						this.pendingIdiomaVisitaCodes = null;
						this.syncActiveLanguagesSourceForCalendar();
					}
					
					// Campos legacy (mantener para compatibilidad)
					this.formControls["FiltrosPorGI"].setValue(filtroKey);
					this.formControls["RangoEdad"].setValue(filtro.RangoEdad || 0);
					this.formControls["TipoTabla"].setValue(filtro.TipoTabla || 0);
					this.formControls["NivelEducativo"].setValue(filtro.NivelEducativo || 0);
					this.formControls["CalendariosDia"].setValue(filtro.CalendariosDia || "");
					if (Array.isArray(filtro.IdiomaVisita)) {
						this.formControls["CalendarioIdiomas"].setValue(filtro.IdiomaVisita.join(','));
					}
				}
			}
			
			// Guardar estado original para detectar cambios
			this.originalCalendarState = JSON.parse(JSON.stringify(data.Calendario));
			this.hasCalendarChanges = false;
		} else {
			// Si no hay calendario, inicializar valores por defecto
			this.originalCalendarState = null;
			this.hasCalendarChanges = false;
		}

		// Parse Botones
		if (data.Botones) {
			let botonesParsed: IBotones;
			if (typeof data.Botones === 'string') {
				try {
					botonesParsed = JSON.parse(data.Botones);
				} catch (e) {
					botonesParsed = {} as IBotones;
				}
			} else {
				botonesParsed = data.Botones as IBotones;
			}

			// Load general buttons - convertir a booleanos para mat-slide-toggle
			if (botonesParsed) {
				this.formControls["Botones_PhoneSell"].setValue(this.convertToBoolean(botonesParsed.PhoneSell), { emitEvent: false });
				this.formControls["Botones_Comprar"].setValue(this.convertToBoolean(botonesParsed.Comprar !== undefined ? botonesParsed.Comprar : 1), { emitEvent: false });
				this.formControls["Botones_Reservar"].setValue(this.convertToBoolean(botonesParsed.Reservar), { emitEvent: false });
				this.formControls["Botones_Factura"].setValue(this.convertToBoolean(botonesParsed.Factura !== undefined ? botonesParsed.Factura : 1), { emitEvent: false });
				this.formControls["Botones_MisCompras"].setValue(this.convertToBoolean(botonesParsed.MisCompras), { emitEvent: false });
				this.formControls["Botones_MisReservas"].setValue(this.convertToBoolean(botonesParsed.MisReservas), { emitEvent: false });
				this.formControls["Botones_MisDatos"].setValue(this.convertToBoolean(botonesParsed.MisDatos), { emitEvent: false });
				this.formControls["Botones_MisOperaciones"].setValue(this.convertToBoolean(botonesParsed.MisOperaciones !== undefined ? botonesParsed.MisOperaciones : 1), { emitEvent: false });
				this.formControls["Botones_PayGold"].setValue(this.convertToBoolean(botonesParsed.PayGold !== undefined ? botonesParsed.PayGold : 1), { emitEvent: false });
				this.formControls["Botones_ComprarMas"].setValue(this.convertToBoolean(botonesParsed.ComprarMas), { emitEvent: false });
				this.formControls["Botones_PagoDiferido"].setValue(this.convertToBoolean(botonesParsed.PagoDiferido !== undefined ? botonesParsed.PagoDiferido : 1), { emitEvent: false });
				// Forzar actualización de los controles de botones
				["Botones_PhoneSell", "Botones_Comprar", "Botones_Reservar", "Botones_Factura", "Botones_MisCompras", "Botones_MisReservas", "Botones_MisDatos", "Botones_MisOperaciones", "Botones_PayGold", "Botones_ComprarMas", "Botones_PagoDiferido"].forEach(controlName => {
					this.formControls[controlName]?.updateValueAndValidity({ emitEvent: false });
				});

				// Load ModoAdmon
				if (botonesParsed.Caducidad?.ModoAdmon) {
					const modoAdmon = botonesParsed.Caducidad.ModoAdmon;
					if (modoAdmon.Modificar) {
						this.formControls["Botones_ModoAdmon_Modificar_Unidades"].setValue(modoAdmon.Modificar.unidades || 0);
						this.formControls["Botones_ModoAdmon_Modificar_Tipo"].setValue(modoAdmon.Modificar.tipo || "");
						this.formControls["Botones_ModoAdmon_Modificar_Hora"].setValue(modoAdmon.Modificar.hora || "");
					}
					if (modoAdmon.Pagar) {
						this.formControls["Botones_ModoAdmon_Pagar_Unidades"].setValue(modoAdmon.Pagar.unidades || 0);
						this.formControls["Botones_ModoAdmon_Pagar_Tipo"].setValue(modoAdmon.Pagar.tipo || "");
						this.formControls["Botones_ModoAdmon_Pagar_Hora"].setValue(modoAdmon.Pagar.hora || "");
					}
					if (modoAdmon.Anular) {
						this.formControls["Botones_ModoAdmon_Anular_Unidades"].setValue(modoAdmon.Anular.unidades || 0);
						this.formControls["Botones_ModoAdmon_Anular_Tipo"].setValue(modoAdmon.Anular.tipo || "");
						this.formControls["Botones_ModoAdmon_Anular_Hora"].setValue(modoAdmon.Anular.hora || "");
					}
				}

				// Load FormasdePago
				if (botonesParsed.Caducidad?.FormasdePago && Array.isArray(botonesParsed.Caducidad.FormasdePago)) {
					const formasPagoArray = this.getFormaPagoControls();
					formasPagoArray.clear();
					botonesParsed.Caducidad.FormasdePago.forEach((formaPago) => {
						const formaPagoForm = this.fb.group({
							CodigosFormaPago: [formaPago.CodigosFormaPago || []],
							Modificar_Unidades: [formaPago.Modificar?.unidades || 0],
							Modificar_Tipo: [formaPago.Modificar?.tipo || ""],
							Modificar_Hora: [formaPago.Modificar?.hora || ""],
							Pagar_Unidades: [formaPago.Pagar?.unidades || 0],
							Pagar_Tipo: [formaPago.Pagar?.tipo || ""],
							Pagar_Hora: [formaPago.Pagar?.hora || ""],
							Anular_Unidades: [formaPago.Anular?.unidades || 0],
							Anular_Tipo: [formaPago.Anular?.tipo || ""],
							Anular_Hora: [formaPago.Anular?.hora || ""]
						});
						formasPagoArray.push(formaPagoForm);
					});
				}

				// Save original state
				this.originalButtonState = JSON.parse(JSON.stringify(botonesParsed));
				this.hasButtonChanges = false;
			}
		} else {
			this.originalButtonState = null;
			this.hasButtonChanges = false;
		}

		// Parse JSONConfiguracion - Otras configuraciones
		if (data.JSONConfiguracion) {
			let jsonConfigParsed: any;
			if (typeof data.JSONConfiguracion === 'string') {
				try {
					jsonConfigParsed = JSON.parse(data.JSONConfiguracion);
				} catch (e) {
					jsonConfigParsed = {};
				}
			} else {
				jsonConfigParsed = data.JSONConfiguracion;
			}

		if (jsonConfigParsed?.CaracteristicasAdicionales) {
			const otrasConfig = jsonConfigParsed.CaracteristicasAdicionales;
			const admiteDtoValue = this.convertToBoolean(otrasConfig.AdmiteDtoPersonalizado ?? otrasConfig.AdmiteDescuentoPersonalizado ?? otrasConfig.AdmiteModelPersonalizado);
			// Load campos principales de CaracteristicasAdicionales
				const saltarValidacionPrecioBoolean = this.convertToBoolean(otrasConfig.SaltarValidacionPrecio);
				const entradasNominativasBoolean = this.convertToBoolean(otrasConfig.EntradasNominativas);
				this.formControls["SaltarValidacionPrecio"].setValue(saltarValidacionPrecioBoolean, { emitEvent: false });
				this.formControls["EntradasNominativas"].setValue(entradasNominativasBoolean, { emitEvent: false });
				this.formControls["SaltarValidacionPrecio"].updateValueAndValidity({ emitEvent: false });
				this.formControls["EntradasNominativas"].updateValueAndValidity({ emitEvent: false });
				
				this.formControls["ValidarHoraVisita"].setValue(otrasConfig.ValidarHoraVisita != null ? otrasConfig.ValidarHoraVisita : "");
				this.formControls["VerEspectaculos"].setValue(otrasConfig.VerEspectaculos != null ? otrasConfig.VerEspectaculos : "");
				this.formControls["CompraDesdeAdmin"].setValue(otrasConfig.CompraDesdeAdmin != null ? otrasConfig.CompraDesdeAdmin : "");
				this.formControls["ValidarReglas"].setValue(otrasConfig.ValidarRN != null ? otrasConfig.ValidarRN : "");
				this.formControls["VerProductosRelacionados"].setValue(otrasConfig.VerProductosRelacionados != null ? otrasConfig.VerProductosRelacionados : "");
				if (otrasConfig.LetraLocalizador != null && otrasConfig.LetraLocalizador !== undefined) {
					this.formControls["LetraLocalizador"].setValue(otrasConfig.LetraLocalizador || "");
				}
				
				// Load all other configuration fields - convertir a booleanos para mat-slide-toggle
				const otrasConfigControls = [
					{ name: "OtrasConfig_DobleLayoutEntradas", value: this.convertToBoolean(otrasConfig.DobleLayoutEntradas !== undefined ? otrasConfig.DobleLayoutEntradas : 1) },
					{ name: "OtrasConfig_ListaEspera", value: this.convertToBoolean(otrasConfig.ListaEspera) },
					{ name: "OtrasConfig_CompraPases", value: this.convertToBoolean(otrasConfig.CompraPases) },
					{ name: "OtrasConfig_AdmiteDtoPersonalizado", value: admiteDtoValue },
					{ name: "OtrasConfig_BloqueoInputFactura", value: this.convertToBoolean(otrasConfig.BloqueoInputFactura) },
					{ name: "OtrasConfig_OcultarAreaPersonal", value: this.convertToBoolean(otrasConfig.OcultarAreaPersonal !== undefined ? otrasConfig.OcultarAreaPersonal : 1) },
					{ name: "OtrasConfig_APIPDFEntradas", value: this.convertToBoolean(otrasConfig.APIPDFEntradas !== undefined ? otrasConfig.APIPDFEntradas : 1) },
					{ name: "OtrasConfig_EnviarEmail", value: this.convertToBoolean(otrasConfig.EnviarEmail) },
					{ name: "OtrasConfig_CodigoClienteAsociado", value: this.convertToBoolean(otrasConfig.CodigoClienteAsociado) },
					{ name: "OtrasConfig_ImportacionExcelNominativas", value: this.convertToBoolean(otrasConfig.ImportacionExcelNominativas) },
					{ name: "OtrasConfig_APIPDFFacturas", value: this.convertToBoolean(otrasConfig.APIPDFFacturas) },
					{ name: "OtrasConfig_APIPassbook", value: this.convertToBoolean(otrasConfig.APIPassbook) },
					{ name: "OtrasConfig_FechaPorRecintoEnPdf", value: this.convertToBoolean(otrasConfig.FechaPorRecintoEnPdf) },
					{ name: "OtrasConfig_MostrarAforoDisponible", value: this.convertToBoolean(otrasConfig.MostrarAforoDisponible) },
					{ name: "OtrasConfig_MostrarItinerario", value: this.convertToBoolean(otrasConfig.MostrarItinerario) },
					{ name: "OtrasConfig_SinPhoneShell", value: this.convertToBoolean(otrasConfig.SinPhoneShell) },
					{ name: "OtrasConfig_CorreoReservaSinTotales", value: this.convertToBoolean(otrasConfig.CorreoReservaSinTotales) },
					{ name: "OtrasConfig_SinTituloExposicionEnResumen", value: this.convertToBoolean(otrasConfig.SinTituloExposicionEnResumen) },
					{ name: "OtrasConfig_BotonMasMenosImagen", value: this.convertToBoolean(otrasConfig.BotonMasMenosImagen) },
					{ name: "OtrasConfig_OcultarClientesReservasAdmin", value: this.convertToBoolean(otrasConfig.OcultarClientesReservasAdmin) },
					{ name: "OtrasConfig_TitularComoVisitante", value: this.convertToBoolean(otrasConfig.TitularComoVisitante) },
					{ name: "OtrasConfig_HoraFinEnSesionFija", value: this.convertToBoolean(otrasConfig.HoraFinEnSesionFija) },
					{ name: "OtrasConfig_MailConfirmacionVentaOpcional", value: this.convertToBoolean(otrasConfig.MailConfirmacionVentaOpcional === 2 ? 1 : 0) },
					{ name: "OtrasConfig_MailConfirmacionReservaOpcional", value: this.convertToBoolean(otrasConfig.MailConfirmacionReservaOpcional === 2 ? 1 : 0) },
					{ name: "OtrasConfig_MostrarIncluyeComision", value: this.convertToBoolean(otrasConfig.MostrarIncluyeComision) },
					{ name: "OtrasConfig_OcultarTarifasSinTraduccion", value: this.convertToBoolean(otrasConfig.OcultarTarifasSinTraduccion) },
					{ name: "OtrasConfig_MostrarIdiomaSesion", value: this.convertToBoolean(otrasConfig.MostrarIdiomaSesion) },
					{ name: "OtrasConfig_EnviarMailCC", value: this.convertToBoolean(otrasConfig.EnviarMailCC) }
				];
				
				otrasConfigControls.forEach(control => {
					this.formControls[control.name]?.setValue(control.value, { emitEvent: false });
					this.formControls[control.name]?.updateValueAndValidity({ emitEvent: false });
				});
				
				this.formControls["OtrasConfig_TiempoValidez"].setValue(otrasConfig.TiempoValidez || "");
				this.formControls["OtrasConfig_TiempoValidezTipo"].setValue(otrasConfig.TiempoValidezTipo || "");
				this.formControls["OtrasConfig_ListadoId"].setValue(otrasConfig.ListadoId || data.ListadoId || "");
				this.formControls["OtrasConfig_ListadoReservaId"].setValue(otrasConfig.ListadoReservaId || data.ListadoReservaId || "");

				// Save original state
				this.originalOtherConfigState = JSON.parse(JSON.stringify(otrasConfig));
				this.hasOtherConfigChanges = false;
			}
		} else {
			this.originalOtherConfigState = null;
			this.hasOtherConfigChanges = false;
		}

		this.panelService.setDiscardChanges(true);
		
		// Forzar detección de cambios para asegurar que los mat-slide-toggle se actualicen
		this.cdr.detectChanges();
	}

	manageForm(pkId, mode) {
		if (mode == "I") {
			this.gruposInternetAsignados = [];
			this.idiomasAsignados = [];
			this.gruposInternetFiltrosAsignados = [];
			this.gruposInternetNoMostrarAsignados = [];
			this.gruposInternetPorRecintoAsignados = [];
			this.idiomasActivosAsignados = [];
			this.pendingIdiomaVisitaCodes = null;
			this.centrosSinAsignar = this.gsCentros.filtrarTiposCentros();
			this.loading = false;
			this.hasCalendarChanges = false;
			this.originalCalendarState = null;
			this.hasButtonChanges = false;
			this.originalButtonState = null;
			this.hasOtherConfigChanges = false;
			this.originalOtherConfigState = null;
			this.valuedChanged();
		}
		if (pkId && (mode == "U" || mode == "D")) {
			// Modo U (Update) o D (Duplicate): cargar datos del enlace menú
			this.findEnlaceMenu(pkId);
		}
	}

	// getDataFromScript(script: string): IEnlaceMenuScript | null {
	// 	//TODO: Se recibe un script como JSON.stringify
	// 	//Hay que parsearlo y obtener los datos para rellenar el formulario
	// 	//Ejemplo de script:
	// 	/*
	// 		"{\"@context\":\"https://schema.org\",\"@type\":\"Event\",\"name\":\"222 Concierto Flamenco en Sacromonte\",\"startDate\":\"2025-09-20T21:00\",\"endDate\":\"2025-09-20T23:00\",\"eventAttendanceMode\":\"https://schema.org/OfflineEventAttendanceMode\",\"eventStatus\":\"https://schema.org/EventScheduled\",\"location\":{\"@type\":\"Place\",\"name\":\"Cueva Flamenca El Sacromonte\",\"address\":{\"@type\":\"PostalAddress\",\"streetAddress\":\"Calle Sacromonte 10\",\"addressLocality\":\"Granada\",\"addressRegion\":\"Andalucía\",\"postalCode\":\"18010\",\"addressCountry\":\"ES\"}},\"image\":\"https://example.com/images/flamenco.jpg\",\"description\":\"Espectáculo de flamenco tradicional en el barrio del Sacromonte.\",\"offers\":{\"@type\":\"Offer\",\"url\":\"https://ventaonline.com/eventos/flamenco-sacromonte\",\"price\":\"40.00\",\"priceCurrency\":\"EUR\",\"availability\":\"https://schema.org/InStock\",\"validFrom\":\"2025-08-01T00:00\"}}"
	// 	*/

	// 	if (!script || script.length === 0) return null;
	// 	try {
	// 		const parsedScript = JSON.parse(script);
	// 		return parsedScript as IEnlaceMenuScript;
	// 	} catch (error) {
	// 		console.error("Error parsing script JSON:", error);
	// 		return null;
	// 	}
	// }

	parseCalendario(): ICalendario | null {
		// Verificar si hay algún cambio en los campos del calendario
		const visibilidad = this.formControls["Visibilidad"].value;
		const defecto = this.formControls["Defecto"].value;
		const paso1 = this.formControls["Paso1"].value;
		const paso2 = this.formControls["Paso2"].value;
		const calDisponible = this.formControls["CalendarioDisponible"].value;
		const calPorRecinto = this.formControls["CalendarioPorRecinto"].value;
		const filtrosGI = this.formControls["FiltrosPorGI_GruposInternet"].value;
		const nivelEducativoValue = this.formControls["FiltrosPorGI_NivelEducativo"].value;
		const rangoEdadValue = this.formControls["FiltrosPorGI_RangoEdad"].value;
		const tipoTablaValue = this.formControls["FiltrosPorGI_TipoTabla"].value;
		const calendariosDiaValue = this.formControls["FiltrosPorGI_CalendariosDia"].value;
		const hasAnyValue = 
			(visibilidad && visibilidad.toString().trim() !== "") ||
			(defecto && defecto.toString().trim() !== "") ||
			(paso1 && paso1.toString().trim() !== "") ||
			(paso2 && paso2.toString().trim() !== "") ||
			calDisponible ||
			calPorRecinto ||
			(Array.isArray(filtrosGI) && filtrosGI.length > 0) ||
			nivelEducativoValue ||
			rangoEdadValue ||
			tipoTablaValue ||
			(calendariosDiaValue && calendariosDiaValue.toString().trim() !== "") ||
			(this.idiomasActivosAsignados && this.idiomasActivosAsignados.length > 0) ||
			(this.gruposInternetNoMostrarAsignados && this.gruposInternetNoMostrarAsignados.length > 0) ||
			(this.gruposInternetPorRecintoAsignados && this.gruposInternetPorRecintoAsignados.length > 0);

		if (!hasAnyValue) {
			return null;
		}

		const calendario: ICalendario = {
			CaracteristicasCalendario: {
				Visibilidad: this.formControls["Visibilidad"].value || "",
				VisibilidadAngular: {
					Defecto: this.formControls["Defecto"].value || "",
					Paso1: this.formControls["Paso1"].value || "",
					Paso2: this.formControls["Paso2"].value || ""
				},
				CaledarioDisponible: this.convertToNumber(this.formControls["CalendarioDisponible"].value) ? "1" : "0",
				CalendarioPorRecinto: this.convertToNumber(this.formControls["CalendarioPorRecinto"].value),
				FiltrosPorGI: {},
				GINoMostrarCalendario: this.gruposInternetNoMostrarAsignados.length > 0 
					? this.gruposInternetNoMostrarAsignados.map(g => g.pkid)
					: [],
				CalendarioPorRecintoGI: this.gruposInternetPorRecintoAsignados.length > 0
					? this.gruposInternetPorRecintoAsignados.map(g => g.pkid)
					: []
			}
		};

		// Construir FiltrosPorGI
		const filtroGIValue = this.formControls["FiltrosPorGI_GruposInternet"].value;
		const nivelEducativo = this.convertToNumber(this.formControls["FiltrosPorGI_NivelEducativo"].value);
		const rangoEdad = this.convertToNumber(this.formControls["FiltrosPorGI_RangoEdad"].value);
		const tipoTabla = this.convertToNumber(this.formControls["FiltrosPorGI_TipoTabla"].value);
		const calendariosDia = this.formControls["FiltrosPorGI_CalendariosDia"].value 
			? parseInt(this.formControls["FiltrosPorGI_CalendariosDia"].value) || 0
			: 0;
		
		// Según documentación API: IdiomaVisita debe ser array de códigos de idioma ["es-ES", "en-GB", "fr", "de-DE"]
		const getLanguageCodeForPayload = (i: any): string | null => {
			if (!i) return null;
			const cod = i._id ?? i.CodIdioma ?? i.codIdioma ?? i.pkId ?? i.pkid ?? i.id ?? i.cod ?? (typeof i === 'string' ? i : null);
			if (cod == null || cod === '') return null;
			const str = String(cod).trim();
			// Si ya es un código tipo locale (ej. es-ES, en-GB, fr), enviarlo tal cual
			if (str.length >= 2 && !/^\d+$/.test(str)) return str;
			// Si es numérico (pkid), resolver a código desde editorListaIdiomas/tiposIdiomas
			const listaRef = this.editorListaIdiomas || this.tiposIdiomas || [];
			const numVal = typeof cod === 'number' ? cod : parseInt(str, 10);
			if (!Number.isNaN(numVal)) {
				const ref = listaRef.find((t: any) => (t?.pkId ?? t?.pkid ?? t?.id ?? t?.CodIdioma ?? t?.codIdioma) == numVal || (t?.pkId ?? t?.pkid ?? t?.id) === numVal);
				const codeRef = ref?.CodIdioma ?? ref?.codIdioma ?? ref?.codigo ?? ref?.Codigo;
				if (codeRef != null && codeRef !== '' && !/^\d+$/.test(String(codeRef))) return String(codeRef).trim();
			}
			// Fallback por nombre
			const nombre = String(i.Nombre ?? i._name ?? i.nombre ?? '').trim().toLowerCase();
			if (!nombre) return str;
			const encontrado = listaRef.find((t: any) => String(t.Nombre ?? t.nombre ?? '').trim().toLowerCase() === nombre);
			const codEncontrado = encontrado?.CodIdioma ?? encontrado?.codIdioma ?? encontrado?.codigo;
			if (codEncontrado != null && codEncontrado !== '' && !/^\d+$/.test(String(codEncontrado))) return String(codEncontrado).trim();
			return str;
		};
		const idiomasVisita = this.idiomasActivosAsignados && this.idiomasActivosAsignados.length > 0
			? this.idiomasActivosAsignados
				.map(getLanguageCodeForPayload)
				.filter((cod): cod is string => cod != null && cod !== "")
			: [];
		
		// Solo incluir FiltrosPorGI si hay algún valor configurado
		const hasFiltrosGI = (Array.isArray(filtroGIValue) && filtroGIValue.length > 0) ||
			nivelEducativo > 0 ||
			rangoEdad > 0 ||
			tipoTabla > 0 ||
			calendariosDia > 0 ||
			idiomasVisita.length > 0;
			
		if (hasFiltrosGI) {
			// Determinar la clave: "0" para todos o el ID del grupo seleccionado
			let key = "0";
			if (Array.isArray(filtroGIValue) && filtroGIValue.length > 0) {
				// Si "0" (Todos) está en el array, usar "0"
				if (filtroGIValue.includes("0")) {
					key = "0";
				} else {
					// Usar el primer ID seleccionado
					key = filtroGIValue[0];
				}
			} else if (filtroGIValue && filtroGIValue !== "0") {
				key = filtroGIValue;
			}

			const filtro: any = {
				NivelEducativo: nivelEducativo,
				RangoEdad: rangoEdad,
				TipoTabla: tipoTabla,
				CalendariosDia: calendariosDia,
				IdiomaVisita: idiomasVisita
			};

			calendario.CaracteristicasCalendario.FiltrosPorGI[key] = filtro;
		}

		return calendario;
	}

	checkCalendarChanges() {
		const currentCalendar = this.parseCalendario();
		const currentStr = JSON.stringify(currentCalendar);
		const originalStr = JSON.stringify(this.originalCalendarState);
		this.hasCalendarChanges = currentStr !== originalStr;
	}

	// Helper methods for FormasdePago FormArray
	getFormaPagoControls(): FormArray {
		return this.editForm.get('Botones_FormasdePago') as FormArray;
	}

	addFormaPagoItem(): void {
		const formaPagoForm = this.fb.group({
			CodigosFormaPago: [[]],
			Modificar_Unidades: [0],
			Modificar_Tipo: [""],
			Modificar_Hora: [""],
			Pagar_Unidades: [0],
			Pagar_Tipo: [""],
			Pagar_Hora: [""],
			Anular_Unidades: [0],
			Anular_Tipo: [""],
			Anular_Hora: [""]
		});
		this.getFormaPagoControls().push(formaPagoForm);
	}

	removeFormaPagoItem(index: number): void {
		this.getFormaPagoControls().removeAt(index);
	}

	parseBotones(): IBotones | null {
		// Check if any button field has been edited (ahora los valores son booleanos)
		const hasGeneralButtons = 
			this.convertToNumber(this.formControls["Botones_PhoneSell"].value) !== 0 ||
			this.convertToNumber(this.formControls["Botones_Comprar"].value) !== 1 ||
			this.convertToNumber(this.formControls["Botones_Reservar"].value) !== 0 ||
			this.convertToNumber(this.formControls["Botones_Factura"].value) !== 1 ||
			this.convertToNumber(this.formControls["Botones_MisCompras"].value) !== 0 ||
			this.convertToNumber(this.formControls["Botones_MisReservas"].value) !== 0 ||
			this.convertToNumber(this.formControls["Botones_MisDatos"].value) !== 0 ||
			this.convertToNumber(this.formControls["Botones_MisOperaciones"].value) !== 1 ||
			this.convertToNumber(this.formControls["Botones_PayGold"].value) !== 1 ||
			this.convertToNumber(this.formControls["Botones_ComprarMas"].value) !== 0 ||
			this.convertToNumber(this.formControls["Botones_PagoDiferido"].value) !== 1;

		const hasModoAdmon = 
			this.formControls["Botones_ModoAdmon_Modificar_Unidades"].value !== 0 ||
			this.formControls["Botones_ModoAdmon_Modificar_Tipo"].value !== "" ||
			this.formControls["Botones_ModoAdmon_Modificar_Hora"].value !== "" ||
			this.formControls["Botones_ModoAdmon_Pagar_Unidades"].value !== 0 ||
			this.formControls["Botones_ModoAdmon_Pagar_Tipo"].value !== "" ||
			this.formControls["Botones_ModoAdmon_Pagar_Hora"].value !== "" ||
			this.formControls["Botones_ModoAdmon_Anular_Unidades"].value !== 0 ||
			this.formControls["Botones_ModoAdmon_Anular_Tipo"].value !== "" ||
			this.formControls["Botones_ModoAdmon_Anular_Hora"].value !== "";

		const formasPagoArray = this.getFormaPagoControls();
		const hasFormasdePago = formasPagoArray.length > 0;

		if (!hasGeneralButtons && !hasModoAdmon && !hasFormasdePago && !this.originalButtonState) {
			return null;
		}

		const botones: IBotones = {
			PhoneSell: this.convertToNumber(this.formControls["Botones_PhoneSell"].value),
			Comprar: this.convertToNumber(this.formControls["Botones_Comprar"].value),
			Reservar: this.convertToNumber(this.formControls["Botones_Reservar"].value),
			Factura: this.convertToNumber(this.formControls["Botones_Factura"].value),
			MisCompras: this.convertToNumber(this.formControls["Botones_MisCompras"].value),
			MisReservas: this.convertToNumber(this.formControls["Botones_MisReservas"].value),
			MisDatos: this.convertToNumber(this.formControls["Botones_MisDatos"].value),
			MisOperaciones: this.convertToNumber(this.formControls["Botones_MisOperaciones"].value),
			PayGold: this.convertToNumber(this.formControls["Botones_PayGold"].value),
			ComprarMas: this.convertToNumber(this.formControls["Botones_ComprarMas"].value),
			PagoDiferido: this.convertToNumber(this.formControls["Botones_PagoDiferido"].value)
		};

		// Add Caducidad if ModoAdmon or FormasdePago have values
		if (hasModoAdmon || hasFormasdePago) {
			botones.Caducidad = {};

			// Add ModoAdmon
			if (hasModoAdmon) {
				botones.Caducidad.ModoAdmon = {
					Modificar: {
						unidades: this.formControls["Botones_ModoAdmon_Modificar_Unidades"].value || 0,
						tipo: this.formControls["Botones_ModoAdmon_Modificar_Tipo"].value || "",
						hora: this.formControls["Botones_ModoAdmon_Modificar_Hora"].value || ""
					},
					Pagar: {
						unidades: this.formControls["Botones_ModoAdmon_Pagar_Unidades"].value || 0,
						tipo: this.formControls["Botones_ModoAdmon_Pagar_Tipo"].value || "",
						hora: this.formControls["Botones_ModoAdmon_Pagar_Hora"].value || ""
					},
					Anular: {
						unidades: this.formControls["Botones_ModoAdmon_Anular_Unidades"].value || 0,
						tipo: this.formControls["Botones_ModoAdmon_Anular_Tipo"].value || "",
						hora: this.formControls["Botones_ModoAdmon_Anular_Hora"].value || ""
					}
				};
			}

			// Add FormasdePago
			if (hasFormasdePago) {
				botones.Caducidad.FormasdePago = formasPagoArray.controls.map((control: any) => {
					const formaPago: any = {
						CodigosFormaPago: control.get('CodigosFormaPago').value || [],
						Modificar: {
							unidades: control.get('Modificar_Unidades').value || 0,
							tipo: control.get('Modificar_Tipo').value || "",
							hora: control.get('Modificar_Hora').value || ""
						},
						Pagar: {
							unidades: control.get('Pagar_Unidades').value || 0,
							tipo: control.get('Pagar_Tipo').value || "",
							hora: control.get('Pagar_Hora').value || ""
						},
						Anular: {
							unidades: control.get('Anular_Unidades').value || 0,
							tipo: control.get('Anular_Tipo').value || "",
							hora: control.get('Anular_Hora').value || ""
						}
					};
					return formaPago;
				});
			}
		}

		return botones;
	}

	checkButtonChanges() {
		const currentBotones = this.parseBotones();
		const currentStr = JSON.stringify(currentBotones);
		const originalStr = JSON.stringify(this.originalButtonState);
		this.hasButtonChanges = currentStr !== originalStr;
	}

	checkOtherConfigChanges() {
		const compraDesdeAdminVal = this.formControls["CompraDesdeAdmin"]?.value;
		const compraDesdeAdmin = (compraDesdeAdminVal === undefined || compraDesdeAdminVal === null || compraDesdeAdminVal === "")
			? null
			: (typeof compraDesdeAdminVal === 'number' ? compraDesdeAdminVal : parseInt(String(compraDesdeAdminVal), 10));
		const otrasConfig: any = {
			VerProductosRelacionados: this.formControls["VerProductosRelacionados"].value,
			VerEspectaculos: this.formControls["VerEspectaculos"].value,
			CompraDesdeAdmin: compraDesdeAdmin,
			DobleLayoutEntradas: this.formControls["OtrasConfig_DobleLayoutEntradas"].value,
			ListaEspera: this.formControls["OtrasConfig_ListaEspera"].value,
			CompraPases: this.formControls["OtrasConfig_CompraPases"].value,
			TiempoValidez: this.formControls["OtrasConfig_TiempoValidez"].value,
			TiempoValidezTipo: this.formControls["OtrasConfig_TiempoValidezTipo"].value,
			AdmiteDtoPersonalizado: this.formControls["OtrasConfig_AdmiteDtoPersonalizado"].value,
			BloqueoInputFactura: this.formControls["OtrasConfig_BloqueoInputFactura"].value,
			OcultarAreaPersonal: this.formControls["OtrasConfig_OcultarAreaPersonal"].value,
			APIPDFEntradas: this.formControls["OtrasConfig_APIPDFEntradas"].value,
			EnviarEmail: this.formControls["OtrasConfig_EnviarEmail"].value,
			CodigoClienteAsociado: this.formControls["OtrasConfig_CodigoClienteAsociado"].value,
			ImportacionExcelNominativas: this.formControls["OtrasConfig_ImportacionExcelNominativas"].value,
			APIPDFFacturas: this.formControls["OtrasConfig_APIPDFFacturas"].value,
			APIPassbook: this.formControls["OtrasConfig_APIPassbook"].value,
			FechaPorRecintoEnPdf: this.formControls["OtrasConfig_FechaPorRecintoEnPdf"].value,
			MostrarAforoDisponible: this.formControls["OtrasConfig_MostrarAforoDisponible"].value,
			MostrarItinerario: this.formControls["OtrasConfig_MostrarItinerario"].value,
			SinPhoneShell: this.formControls["OtrasConfig_SinPhoneShell"].value,
			CorreoReservaSinTotales: this.formControls["OtrasConfig_CorreoReservaSinTotales"].value,
			SinTituloExposicionEnResumen: this.formControls["OtrasConfig_SinTituloExposicionEnResumen"].value,
			BotonMasMenosImagen: this.formControls["OtrasConfig_BotonMasMenosImagen"].value,
			OcultarClientesReservasAdmin: this.formControls["OtrasConfig_OcultarClientesReservasAdmin"].value,
			TitularComoVisitante: this.formControls["OtrasConfig_TitularComoVisitante"].value,
			HoraFinEnSesionFija: this.formControls["OtrasConfig_HoraFinEnSesionFija"].value,
			MailConfirmacionVentaOpcional: this.formControls["OtrasConfig_MailConfirmacionVentaOpcional"].value ? 2 : 0,
			MailConfirmacionReservaOpcional: this.formControls["OtrasConfig_MailConfirmacionReservaOpcional"].value ? 2 : 0,
			MostrarIncluyeComision: this.formControls["OtrasConfig_MostrarIncluyeComision"].value,
			OcultarTarifasSinTraduccion: this.formControls["OtrasConfig_OcultarTarifasSinTraduccion"].value,
			MostrarIdiomaSesion: this.formControls["OtrasConfig_MostrarIdiomaSesion"].value,
			EnviarMailCC: this.formControls["OtrasConfig_EnviarMailCC"].value,
			ListadoId: this.formControls["OtrasConfig_ListadoId"].value,
			ListadoReservaId: this.formControls["OtrasConfig_ListadoReservaId"].value
		};

		const currentStr = JSON.stringify(otrasConfig);
		const originalStr = JSON.stringify(this.originalOtherConfigState);
		this.hasOtherConfigChanges = currentStr !== originalStr;
	}

	parseJSONConfiguracion(json) {
		let jsonConfigParsed: any;
		if (typeof json === 'string') {
			try {
				jsonConfigParsed = JSON.parse(json);
			} catch (e) {
				jsonConfigParsed = {};
			}
		} else {
			jsonConfigParsed = json || {};
		}

		// Asegurar valores por defecto para campos obligatorios en CaracteristicasAdicionales
		// Estos campos deben ser números según el cURL válido
		const validarHoraVisita = this.formControls["ValidarHoraVisita"]?.value !== undefined && this.formControls["ValidarHoraVisita"]?.value !== null 
			? (typeof this.formControls["ValidarHoraVisita"].value === 'string' ? parseInt(this.formControls["ValidarHoraVisita"].value) || 0 : this.formControls["ValidarHoraVisita"].value)
			: 0;
		const saltarValidacionPrecio = this.convertToNumber(this.formControls["SaltarValidacionPrecio"]?.value);
		const entradasNominativas = this.convertToNumber(this.formControls["EntradasNominativas"]?.value);
		const validarRN = this.formControls["ValidarReglas"]?.value !== undefined && this.formControls["ValidarReglas"]?.value !== null
			? (typeof this.formControls["ValidarReglas"].value === 'string' ? parseInt(this.formControls["ValidarReglas"].value) || 1 : this.formControls["ValidarReglas"].value)
			: 1;

		const letraLocalizador = (this.formControls["LetraLocalizador"]?.value ?? "") || "";
		// Otras configuraciones: siempre desde el formulario para que AdmiteDtoPersonalizado, MostrarIdiomaSesion, etc. se envíen siempre
		const admiteFormValue = this.formControls["OtrasConfig_AdmiteDtoPersonalizado"]?.value;
		const compraDesdeAdminRaw = this.formControls["CompraDesdeAdmin"]?.value;
		const compraDesdeAdminPayload = (compraDesdeAdminRaw === undefined || compraDesdeAdminRaw === null || compraDesdeAdminRaw === "")
			? null
			: (typeof compraDesdeAdminRaw === 'number' ? compraDesdeAdminRaw : parseInt(String(compraDesdeAdminRaw), 10));
		const otrasConfigFromForm = {
			CompraDesdeAdmin: compraDesdeAdminPayload,
			DobleLayoutEntradas: this.formControls["OtrasConfig_DobleLayoutEntradas"]?.value !== undefined && this.formControls["OtrasConfig_DobleLayoutEntradas"]?.value !== null
				? (this.formControls["OtrasConfig_DobleLayoutEntradas"].value ? 1 : 0)
				: 1,
			ListaEspera: this.convertToNumber(this.formControls["OtrasConfig_ListaEspera"]?.value),
			CompraPases: this.convertToNumber(this.formControls["OtrasConfig_CompraPases"]?.value),
			TiempoValidez: this.formControls["OtrasConfig_TiempoValidez"]?.value !== undefined && this.formControls["OtrasConfig_TiempoValidez"]?.value !== null
				? (typeof this.formControls["OtrasConfig_TiempoValidez"].value === 'string' ? parseInt(this.formControls["OtrasConfig_TiempoValidez"].value) || 1 : this.formControls["OtrasConfig_TiempoValidez"].value)
				: 1,
			TiempoValidezTipo: (this.formControls["OtrasConfig_TiempoValidezTipo"]?.value || "MY") as string,
			AdmiteDtoPersonalizado: this.convertToNumber(admiteFormValue),
			AdmiteModelPersonalizado: this.convertToNumber(admiteFormValue),
			BloqueoInputFactura: this.convertToNumber(this.formControls["OtrasConfig_BloqueoInputFactura"]?.value),
			OcultarAreaPersonal: this.formControls["OtrasConfig_OcultarAreaPersonal"]?.value !== undefined && this.formControls["OtrasConfig_OcultarAreaPersonal"]?.value !== null
				? (this.formControls["OtrasConfig_OcultarAreaPersonal"].value ? 1 : 0)
				: 1,
			APIPDFEntradas: this.formControls["OtrasConfig_APIPDFEntradas"]?.value !== undefined && this.formControls["OtrasConfig_APIPDFEntradas"]?.value !== null
				? (this.formControls["OtrasConfig_APIPDFEntradas"].value ? 1 : 0)
				: 1,
			EnviarEmail: this.convertToNumber(this.formControls["OtrasConfig_EnviarEmail"]?.value),
			CodigoClienteAsociado: this.convertToNumber(this.formControls["OtrasConfig_CodigoClienteAsociado"]?.value),
			ImportacionExcelNominativas: this.convertToNumber(this.formControls["OtrasConfig_ImportacionExcelNominativas"]?.value),
			APIPDFFacturas: this.convertToNumber(this.formControls["OtrasConfig_APIPDFFacturas"]?.value),
			APIPassbook: this.convertToNumber(this.formControls["OtrasConfig_APIPassbook"]?.value),
			FechaPorRecintoEnPdf: this.convertToNumber(this.formControls["OtrasConfig_FechaPorRecintoEnPdf"]?.value),
			MostrarAforoDisponible: this.convertToNumber(this.formControls["OtrasConfig_MostrarAforoDisponible"]?.value),
			MostrarItinerario: this.convertToNumber(this.formControls["OtrasConfig_MostrarItinerario"]?.value),
			SinPhoneShell: this.convertToNumber(this.formControls["OtrasConfig_SinPhoneShell"]?.value),
			CorreoReservaSinTotales: this.convertToNumber(this.formControls["OtrasConfig_CorreoReservaSinTotales"]?.value),
			SinTituloExposicionEnResumen: this.convertToNumber(this.formControls["OtrasConfig_SinTituloExposicionEnResumen"]?.value),
			BotonMasMenosImagen: this.convertToNumber(this.formControls["OtrasConfig_BotonMasMenosImagen"]?.value),
			OcultarClientesReservasAdmin: this.convertToNumber(this.formControls["OtrasConfig_OcultarClientesReservasAdmin"]?.value),
			TitularComoVisitante: this.convertToNumber(this.formControls["OtrasConfig_TitularComoVisitante"]?.value),
			HoraFinEnSesionFija: this.convertToNumber(this.formControls["OtrasConfig_HoraFinEnSesionFija"]?.value),
			MailConfirmacionVentaOpcional: this.formControls["OtrasConfig_MailConfirmacionVentaOpcional"]?.value ? 2 : 0,
			MailConfirmacionReservaOpcional: this.formControls["OtrasConfig_MailConfirmacionReservaOpcional"]?.value ? 2 : 0,
			MostrarIncluyeComision: this.convertToNumber(this.formControls["OtrasConfig_MostrarIncluyeComision"]?.value),
			OcultarTarifasSinTraduccion: this.convertToNumber(this.formControls["OtrasConfig_OcultarTarifasSinTraduccion"]?.value),
			MostrarIdiomaSesion: this.convertToNumber(this.formControls["OtrasConfig_MostrarIdiomaSesion"]?.value),
			EnviarMailCC: this.convertToNumber(this.formControls["OtrasConfig_EnviarMailCC"]?.value),
			ListadoId: this.formControls["OtrasConfig_ListadoId"]?.value,
			ListadoReservaId: this.formControls["OtrasConfig_ListadoReservaId"]?.value
		};
		const { DatosCompraPoliticaControl: _omitPolitica, ...restCaracteristicas } = jsonConfigParsed.CaracteristicasAdicionales || {};
		const jsonConfiguracion = {
			...jsonConfigParsed,
			CaracteristicasAdicionales: {
				...restCaracteristicas,
				ValidarHoraVisita: validarHoraVisita,
				SaltarValidacionPrecio: saltarValidacionPrecio,
				EntradasNominativas: entradasNominativas,
				ValidarRN: validarRN,
				VerProductosRelacionados: this.toNumberOrZero(this.formControls["VerProductosRelacionados"]?.value),
				VerEspectaculos: this.toNumberOrZero(this.formControls["VerEspectaculos"]?.value),
				LetraLocalizador: letraLocalizador,
				DatosCompra: this.getAllForPayload(this.datosCompra),
				DatosPublicidad: this.getAllForPayload(this.datosPublicidad),
				DatosCompraControl: this.getAllForPayload(this.datosCompraControl),
				datosCompraPoliticaControl: this.getAllForPayload(this.datosCompraPoliticaControl),
				DatosFactura: this.getAllForPayload(this.datosFactura),
				PasesDatosPersonales: this.getAllForPayload(this.pasesDatosPersonales),
				...otrasConfigFromForm
			},
		};

		// Retornar objeto en lugar de string JSON
		return jsonConfiguracion;
	}

	ValidatorURL(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const urlPattern = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
			const valid = urlPattern.test(control.value);
			return valid ? null : { invalidUrl: true };
		};
	}

	ValidatorImageURL(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const imageUrlPattern = /(https?:\/\/.*\.(?:png|jpg))/i;
			const valid = imageUrlPattern.test(control.value);
			return valid ? null : { invalidImageUrl: true };
		};
	}

	ValidatorDatePicker(required = false): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			if (required && !control.value) {
				return { required: true };
			}

			return null;
			
		}
	}

	get formControls() {
		return this.editForm.controls;
	}

	/** Actualiza el estado disabled del control Padre según Nivel: solo habilitado cuando Nivel > 0 */
	private updatePadreDisabledState(): void {
		const nivelCtrl = this.editForm?.get("Nivel");
		const padreCtrl = this.editForm?.get("Padre");
		if (!nivelCtrl || !padreCtrl) return;
		const val = nivelCtrl.value;
		const num = typeof val === "string" ? parseInt(val, 10) : Number(val);
		if (isNaN(num) || num <= 0) {
			padreCtrl.disable({ emitEvent: false });
		} else {
			padreCtrl.enable({ emitEvent: false });
		}
	}

	private setupNivelPadreSubscription(): void {
		const nivelCtrl = this.editForm?.get("Nivel");
		const padreCtrl = this.editForm?.get("Padre");
		if (!nivelCtrl || !padreCtrl) return;
		this.updatePadreDisabledState();
		nivelCtrl.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((val) => {
			const num = typeof val === "string" ? parseInt(val, 10) : Number(val);
			if (isNaN(num) || num === 0) {
				padreCtrl.setValue("", { emitEvent: false });
				padreCtrl.disable({ emitEvent: false });
			} else {
				padreCtrl.enable({ emitEvent: false });
			}
			padreCtrl.updateValueAndValidity({ emitEvent: false });
		});
	}

	submit() {
		const enlacemenuFormValue: IEnlaceMenuFormValue = this.editForm.value;
		this.editForm.markAllAsTouched();

		// Validar que al menos un GrupoInternet esté seleccionado
		if (!this.gruposInternetAsignados || this.gruposInternetAsignados.length === 0) {
			const msgGrupo = (this.translation?.ErrorGrupoInternetParaGuardar ?? "Debe seleccionar al menos un Grupo Internet para poder guardar");
			this.snackvar_service.openSnackBar(msgGrupo, "", "red-snackbar");
			return;
		}

		// Secciones obligatorias (Ver sección 2.7): al menos un elemento en cada una. Pases datos personales es opcional.
		const t = this.translation || {};
		const seccionesObligatorias: { nombre: string; vacia: boolean }[] = [
			{ nombre: t.DatosCompra ?? "Datos compra", vacia: !this.datosCompra?.length },
			{ nombre: t.Publicidad ?? "Publicidad", vacia: !this.datosPublicidad?.length },
			{ nombre: t.DatosCompraControl ?? "Datos compra control", vacia: !this.datosCompraControl?.length },
			{ nombre: t.DatosCompraPoliticaControl ?? "Datos compra política control", vacia: !this.datosCompraPoliticaControl?.length },
			{ nombre: t.DatosFactura ?? "Datos factura", vacia: !this.datosFactura?.length },
		];
		const faltantes = seccionesObligatorias.filter((s) => s.vacia);
		if (faltantes.length > 0) {
			const nombres = faltantes.map((s) => s.nombre).join(", ");
			const msg = (t.SeccionesObligatoriasDebeSeleccionar ?? "Las siguientes secciones son obligatorias. Debe seleccionar al menos un elemento en:") + " " + nombres;
			this.snackvar_service.openSnackBar(msg, "", "red-snackbar");
			return;
		}

		if (this.editForm.valid) {
			this.manageApi(enlacemenuFormValue);
		}
	}

	destroy() {
		this.panelService.setDiscardChanges(true);
		this.panelService.setClosePanel(null);
	}
	save() {
		this.loading = false;
		this.panelService.setSavePanel(null);
	}

	discard() {
		this.changeValueForm(this.entityValue);
		this.editForm.markAllAsTouched();

		switch (this.mode) {
			case "I":
				this.gruposInternetAsignados = [];
				this.idiomasAsignados = [];
				break;
			case "U":
			case "D":
				const giEnlace = this.entityValue?.GruposInternet || [];
				const giIds = Array.isArray(giEnlace)
					? (giEnlace as any[]).reduce((curr: string, acc: any) => curr + (curr ? ',' : '') + (acc?.GrupoInternetId ?? acc), '') || ''
					: String(giEnlace);
				this.gruposInternetAsignados = this.getGruposInternetAsignados(giIds);
				// Limitar opciones de Calendario a los Grupos Internet del enlace
				this.gruposInternetFiltrosSinAsignar = [...this.gruposInternetAsignados];
				this.gruposInternetNoMostrarSinAsignar = [...this.gruposInternetAsignados];
				this.gruposInternetPorRecintoSinAsignar = [...this.gruposInternetAsignados];
				break;

			default:
				break;
		}
	}

	// obtenerDualListAsignados(value: any[]): string {
	// 	if (!value || value.length === 0) return '';
	// 	return value.map(item => item.pkid).join(',');
	// }

	// generateScript(formData: IEnlaceMenuFormValue): IEnlaceMenuScript {
	// 	const script: IEnlaceMenuScript = {
	// 		"@context": "https://schema.org",
	// 		"@type": "Event",
	// 		"name": formData.NombreEvento || '',
	// 		"startDate": formData.FechaDeInicio
	// 			? (formData.HoraInicio
	// 				? moment(formData.FechaDeInicio).set({
	// 						hour: +formData.HoraInicio.split(':')[0],
	// 						minute: +formData.HoraInicio.split(':')[1]
	// 					}).toISOString()
	// 				: moment(formData.FechaDeInicio).toISOString())
	// 			: '',
	// 		"endDate": formData.FechaDeFin
	// 			? (formData.HoraFin 
	// 				? moment(formData.FechaDeFin).set({
	// 						hour: +formData.HoraFin.split(':')[0],
	// 						minute: +formData.HoraFin.split(':')[1]
	// 					}).toISOString() 
	// 				: moment(formData.FechaDeFin).toISOString()) 
	// 			: '',
	// 		"eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
	// 		"image": formData.URLImagen || '',
	// 		"description": formData.DescripcionEvento || '',
	// 		"eventStatus": "https://schema.org/EventScheduled",
	// 		"location": {
	// 			"@type": "Place",
	// 			"name": formData.NombreLugarEvento || '',
	// 			"address": {
	// 				"@type": "PostalAddress",
	// 				"streetAddress": formData.Direccion || '',
	// 				"addressLocality": formData.Localidad || '',
	// 				"addressRegion": formData.Region || '',
	// 				"postalCode": formData.CodigoPostal || '',
	// 				"addressCountry": formData.PaisCodigo || ''
	// 			}
	// 		},
	// 		"organizer": {
	// 			"@type": "Organization",
	// 			"name": formData.NombreOrganizador || '',
	// 			"url": formData.WebOrganizador || ''
	// 		}
	// 	};

	// 	return script;
	// }

	manageApi( formData: IEnlaceMenuFormValue ) {

		//const gruposInternetIds = this.obtenerDualListAsignados(this.gruposInternetAsignados);
		
		this.loading = true;

		// const scriptValue = this.generateScript(formData);

		// Verificar si hay cambios en el calendario
		this.checkCalendarChanges();
		const calendarioParsed = this.parseCalendario();

		// Verificar cambios en botones y otras configuraciones
		this.checkButtonChanges();
		this.checkOtherConfigChanges();
		
		// Parse botones - ahora como objeto, no string
		const botonesParsed = this.parseBotones();
		let botonesObject: IBotones;
		if (botonesParsed) {
			botonesObject = botonesParsed;
		} else if (this.originalButtonState) {
			botonesObject = this.originalButtonState;
		} else if (formData.Botones) {
			// Intentar parsear el string de botones existente
			try {
				const parsed = typeof formData.Botones === 'string' ? JSON.parse(formData.Botones) : formData.Botones;
				botonesObject = parsed;
			} catch (e) {
				botonesObject = {} as IBotones;
			}
		} else {
			botonesObject = {} as IBotones;
		}
		(Object.keys(BOTONES_DEFAULT) as (keyof IBotones)[]).forEach(k => {
			if (botonesObject[k] === undefined) { botonesObject[k] = BOTONES_DEFAULT[k] as number; }
		});

		// Asegurar valores por defecto para campos obligatorios
		const tiempoVentaMax = formData.TiempoVentaMax || "0";
		const tiempoVentaMaxTipo = formData.TiempoVentaMaxTipo || "dias";
		const tiempoReservaMax = formData.TiempoReservaMax || "0";
		const tiempoReservaMaxTipo = formData.TiempoReservaMaxTipo || "dias";
		const logueo = formData.Logueo || "0";
		const solicitaVerificarRegistro = formData.SolicitaVerificarRegistro || "0"; // Obligatorio
		const solicitaFactura = formData.SolicitaFactura || "0";
		// TiposClientes: el form guarda array (mat-select multiple); la API espera string "1,2,3"
		const tiposClientesValue = this.editForm.get("TiposClientes")?.value;
		const tiposClientes = (Array.isArray(tiposClientesValue) && tiposClientesValue.length > 0)
			? tiposClientesValue.map((id: any) => String(id)).join(",")
			: "1";
		const listadoId = formData.ListadoId || this.formControls["OtrasConfig_ListadoId"]?.value || "";
		const listadoReservaId = formData.ListadoReservaId || this.formControls["OtrasConfig_ListadoReservaId"]?.value || "";
		
		// Obtener ClaveEmpresa de la configuración (como en otros componentes)
		const claveEmpresa = this.tokenService.getConfig("chClaveEmpresa") || "";

		// Validación de seguridad: asegurar que haya al menos un GrupoInternet seleccionado
		if (!this.gruposInternetAsignados || this.gruposInternetAsignados.length === 0) {
			this.snackvar_service.openSnackBar(
				"Debe seleccionar al menos un Grupo Internet para poder guardar",
				"",
				"red-snackbar"
			);
			this.loading = false;
			return;
		}

		// Transformar GruposInternet al formato esperado por la API
		const gruposInternetFormatted = (this.gruposInternetAsignados || []).map((grupo: any) => ({
			GrupoInternetId: grupo.pkid || grupo.GrupoInternetId || grupo.id,
			ListadoId: listadoId ? (typeof listadoId === 'string' && listadoId.trim() !== '' ? parseInt(listadoId) : (typeof listadoId === 'number' ? listadoId : undefined)) : undefined,
			ListadoReservaId: listadoReservaId ? (typeof listadoReservaId === 'string' && listadoReservaId.trim() !== '' ? parseInt(listadoReservaId) : (typeof listadoReservaId === 'number' ? listadoReservaId : undefined)) : undefined
		})).filter((grupo: any) => grupo.GrupoInternetId !== undefined);

		// Validación adicional: asegurar que después del filtrado haya al menos un elemento
		if (gruposInternetFormatted.length === 0) {
			this.snackvar_service.openSnackBar(
				"Debe seleccionar al menos un Grupo Internet válido para poder guardar",
				"",
				"red-snackbar"
			);
			this.loading = false;
			return;
		}

		// Construir Idiomas: unión de idiomas cargados (idiomasAsignados) y añadidos en el dual list (idiomasActivosAsignados)
		const codsAsignados = new Set<string>();
		const idiomasParaEnviar: any[] = [];
		(this.idiomasAsignados || []).forEach((idioma: any) => {
			const cod = idioma.CodIdioma || idioma.codIdioma;
			if (cod && !codsAsignados.has(cod)) {
				codsAsignados.add(cod);
				idiomasParaEnviar.push(idioma);
			}
		});
		(this.idiomasActivosAsignados || []).forEach((idioma: any) => {
			const cod = idioma.CodIdioma || idioma.codIdioma;
			if (cod && !codsAsignados.has(cod)) {
				codsAsignados.add(cod);
				idiomasParaEnviar.push({
					CodIdioma: cod,
					Nombre: idioma.Nombre || idioma.nombre || "",
					Descripcion: idioma.Descripcion || idioma.descripcion || "",
					NombreBoton: idioma.NombreBoton || idioma.nombreBoton || "",
					TextoAmigable: idioma.TextoAmigable || idioma.textoAmigable || "",
					UrlExterna: idioma.UrlExterna || idioma.urlExterna || ""
				});
			}
		});
		// Incluir idiomas del acordeón con datos en el formulario (ej. catalán "ca") aunque no estén en dual list
		(this.editorListaIdiomas || []).forEach((idioma: any) => {
			const cod = idioma.CodIdioma || idioma.codIdioma;
			if (!cod || codsAsignados.has(cod)) { return; }
			const nombre = this.formControls["Nombre-" + cod]?.value;
			const descripcion = this.formControls["Descripcion-" + cod]?.value;
			const nombreBoton = this.formControls["NombreBoton-" + cod]?.value;
			const textoAmigable = this.formControls["TextoAmigable-" + cod]?.value;
			const urlExterna = this.formControls["UrlExterna-" + cod]?.value;
			const hasValue = (nombre != null && String(nombre).trim() !== "") ||
				(descripcion != null && String(descripcion).trim() !== "") ||
				(nombreBoton != null && String(nombreBoton).trim() !== "") ||
				(textoAmigable != null && String(textoAmigable).trim() !== "") ||
				(urlExterna != null && String(urlExterna).trim() !== "");
			if (hasValue) {
				codsAsignados.add(cod);
				idiomasParaEnviar.push({
					CodIdioma: cod,
					Nombre: nombre ?? "",
					Descripcion: descripcion ?? "",
					NombreBoton: nombreBoton ?? "",
					TextoAmigable: textoAmigable ?? "",
					UrlExterna: urlExterna ?? ""
				});
			}
		});
		const idiomasFormatted = idiomasParaEnviar.map((idioma: any) => {
			const cod = idioma.CodIdioma || idioma.codIdioma;
			return {
				CodIdioma: cod,
				NombreIdioma: this.formControls["Nombre-" + cod]?.value ?? idioma.Nombre ?? idioma.NombreIdioma ?? "",
				DescripcionIdioma: this.formControls["Descripcion-" + cod]?.value ?? idioma.Descripcion ?? idioma.DescripcionIdioma ?? "",
				nombreBoton: this.formControls["NombreBoton-" + cod]?.value ?? idioma.NombreBoton ?? idioma.nombreBoton ?? "",
				TextoAmigable: this.formControls["TextoAmigable-" + cod]?.value ?? idioma.TextoAmigable ?? idioma.textoAmigable ?? "",
				urlExterna: this.formControls["UrlExterna-" + cod]?.value ?? idioma.UrlExterna ?? idioma.urlExterna ?? ""
			};
		}).filter((idioma: any) => idioma.CodIdioma);

		const bodyRequest: InsUpEnlaceMenuRequest = {
			pkId: 0, // Cambiado de pkid a pkId
			Nombre: formData.Nombre,
			Descripcion: formData.Descripcion || "",
			TipoEnlace: formData.TipoEnlace !== null && formData.TipoEnlace !== undefined && formData.TipoEnlace !== ""
				? (typeof formData.TipoEnlace === 'string' ? parseInt(formData.TipoEnlace) || 0 : formData.TipoEnlace)
				: 0,
			Visible: this.convertToNumber(formData.Visible),
			SinFecha: this.convertToNumber(formData.SinFecha),
			VerCodigosPromocionales: formData.VerCodigosPromocionales ? (typeof formData.VerCodigosPromocionales === 'string' ? parseInt(formData.VerCodigosPromocionales) || 0 : formData.VerCodigosPromocionales) : 0,
			Activo: this.convertToNumber(formData.Activo),
			Nivel: formData.Nivel ? (typeof formData.Nivel === 'string' ? parseInt(formData.Nivel) || 0 : formData.Nivel) : 0,
			Padre: formData.Padre ? (typeof formData.Padre === 'string' ? parseInt(formData.Padre) || 0 : formData.Padre) : 0,
			Orden: formData.Orden ? (typeof formData.Orden === 'string' ? parseInt(formData.Orden) || 1 : formData.Orden) : 1,
			DiasCalendario: formData.DiasCalendario ? (typeof formData.DiasCalendario === 'string' ? parseInt(formData.DiasCalendario) || 1 : formData.DiasCalendario) : 1,
			TiempoVentaMin: formData.TiempoVentaMin ? (typeof formData.TiempoVentaMin === 'string' ? parseInt(formData.TiempoVentaMin) || 1 : formData.TiempoVentaMin) : 1,
			TiempoVentaMinTipo: formData.TiempoVentaMinTipo || "dias",
			TiempoVentaMax: tiempoVentaMax ? (typeof tiempoVentaMax === 'string' ? parseInt(tiempoVentaMax) || 1 : tiempoVentaMax) : 1, // Obligatorio
			TiempoVentaMaxTipo: tiempoVentaMaxTipo || "dias", // Obligatorio
			TiempoReservaMin: formData.TiempoReservaMin ? (typeof formData.TiempoReservaMin === 'string' ? parseInt(formData.TiempoReservaMin) || 1 : formData.TiempoReservaMin) : 1,
			TiempoReservaMinTipo: formData.TiempoReservaMinTipo || "dias",
			TiempoReservaMax: tiempoReservaMax ? (typeof tiempoReservaMax === 'string' ? parseInt(tiempoReservaMax) || 1 : tiempoReservaMax) : 1, // Obligatorio
			TiempoReservaMaxTipo: tiempoReservaMaxTipo || "dias", // Obligatorio
			Logueo: logueo ? (typeof logueo === 'string' ? parseInt(logueo) || 0 : logueo) : 0, // Obligatorio
			SolicitaVerificarRegistro: solicitaVerificarRegistro ? (typeof solicitaVerificarRegistro === 'string' ? parseInt(solicitaVerificarRegistro) || 0 : solicitaVerificarRegistro) : 0, // Obligatorio
			SolicitaFactura: solicitaFactura ? (typeof solicitaFactura === 'string' ? parseInt(solicitaFactura) || 0 : solicitaFactura) : 0, // Obligatorio
			TiposClientes: tiposClientes, // Obligatorio
			Idiomas: idiomasFormatted, // Formato correcto según cURL válido
			Botones: botonesObject, // Ahora es un objeto, no un string
			ClaveEmpresa: claveEmpresa || formData.ClaveEmpresa || "",
			GruposInternet: gruposInternetFormatted, // Formato correcto según cURL válido
			JSONConfiguracion: this.parseJSONConfiguracion(formData.JSONConfiguracion), // Ahora retorna objeto, no string
			ListadoId: listadoId ? (typeof listadoId === 'string' && listadoId.trim() !== '' ? parseInt(listadoId) || listadoId : listadoId) : undefined,
			ListadoReservaId: listadoReservaId ? (typeof listadoReservaId === 'string' && listadoReservaId.trim() !== '' ? parseInt(listadoReservaId) || listadoReservaId : listadoReservaId) : undefined,
			Audioguia: this.convertToNumber(this.formControls["Audioguia"]?.value)
		};

		// Solo incluir Calendario si hay valores editados o si existe un calendario original
		if (calendarioParsed) {
			// Hay valores nuevos editados, enviar el calendario parseado
			bodyRequest.Calendario = calendarioParsed;
		} else if (this.originalCalendarState) {
			// Hay un calendario original, mantenerlo (ya sea con o sin cambios)
			bodyRequest.Calendario = this.originalCalendarState;
		}
		// Si no hay calendarioParsed ni originalCalendarState, no incluir el campo (será undefined)

		switch (this.mode) {
			case "I":
			case "D":
				bodyRequest.pkId = 0; // Cambiado de pkid a pkId
				this.InsUpEventoEnlace(bodyRequest);
				//insert
				break;
			case "U":
				//update
				bodyRequest.pkId = +this.pkId; // Cambiado de pkid a pkId
				this.InsUpEventoEnlace(bodyRequest);
				break;
			default:
				break;
		}
	}

	InsUpEventoEnlace(bodyRequest: InsUpEnlaceMenuRequest) {
		this.conectarApiService
			.InsUpEnlacesMenu(bodyRequest)
			.pipe(takeUntil(this.ngUnsubscribe))
			.subscribe(
				(response) => {
					this.nextWindow(response);
				},
				(error) => {
					this.httpErrorService.identificarErrores(error);
				}
			);
	}

	nextWindow(response: InsUpEnlaceMenuResponse) {
		this.save();

		// API devuelve PascalCase (DatosResult, Mensajes, CodigoMensaje, DescripcionMensaje)
		const datosResult = (response as any).DatosResult ?? response?.datosResult;
		const mensajes = (response as any).Mensajes ?? response?.mensajes ?? [];

		const isError = datosResult == null || (Array.isArray(mensajes) && mensajes.length > 0);

		const successMessageKey = {
			I: "CreatedSuccessfully",
			U: "UpdatedSuccessfully",
			D: "DuplicatedSuccessfully",
		};

		if (isError) {
			if (Array.isArray(mensajes) && mensajes.length > 0) {
				mensajes.forEach((element: any) => {
					const texto = element.DescripcionMensaje ?? element.descripcionMensaje ?? "";
					this.snackvar_service.openSnackBar(texto, "", "red-snackbar");
				});
			} else {
				this.snackvar_service.openSnackBar(
					this.translation["ErrorGeneral"] || "Error al guardar el registro.",
					"",
					"red-snackbar"
				);
			}
		} else {
			this.snackvar_service.openSnackBar(
				this.translation[successMessageKey[this.mode]],
				"",
				"green-snackbar"
			);
			this.destroy();
		}
	}

	notEmptyFields(grupo_cl: GrupoClientes): boolean {
		let res = true;
		if (
			grupo_cl.NombreGruposClientes.length === 0 ||
			grupo_cl.CodigoGruposClientes.length === 0
		) {
			res = false;
		}
		return res;
	}

	valuedChanged() {
		this.editForm.valueChanges.subscribe((value) => {
			if (this.padres !== null) {
				this.panelService.setDiscardChanges(false);
				if (JSON.stringify(value) === JSON.stringify(this.entityValue)) {
					this.panelService.setDiscardChanges(true);
				}
			}
		});
	}

	validateFields(field: string) {
		return this.isValidAnyField(field);
	}

	isValidAnyField(field: string) {
		let fc_pv = this.formControls;
		return fc_pv[field].errors != null ? true : false;
	}

	getErrorMessage(field: string) {
		const fc_pv = this.editForm.get(field);
		if (!fc_pv || !fc_pv.errors) {
			return "";
		}

		const errorsText: Record<string, string> = {
			required: this.translation["CampoRequerido"],
			invalidUrl: this.translation["INVALID_URL"],
			invalidImageUrl: this.translation["INVALID_IMAGE_URL"],
			invalidDate: this.translation["FechaInvalida"],
			invalidHour: this.translation["HoraInvalida"]
		};

		if (fc_pv.errors.maxlength) {
			const requiredLength = fc_pv.errors.maxlength.requiredLength;
			return this.translation["MaximoCaracteres"] || `Máximo ${requiredLength} caracteres permitidos`;
		}
		if (fc_pv.errors.pattern) {
			return this.translation["CampoRequerido"] || "Formato o longitud no válidos";
		}

		for (const errorName in fc_pv.errors) {
			if (errorsText[errorName]) {
				return errorsText[errorName];
			}
		}
		return "Error";
	}

	onTotalElementsHtmlChange(source: string, $event: any[]) {
		switch (source) {
			case 'compra':
				this.datosCompra = $event;
				break;
			case 'publicidad':
				this.datosPublicidad = $event;
				break;
			case 'compraControl':
				this.datosCompraControl = $event;
				break;
			case 'compraPoliticaControl':
				this.datosCompraPoliticaControl = $event;
				break;
			case 'factura':
				this.datosFactura = $event;
				break;
			case 'pasesPersonales':
				this.pasesDatosPersonales = $event;
				break;
			default:
				break;
		}
	}
}
